/* iSell & Repair — Reparações (prototype logic).
   Plain JS, no dependencies. Everything marked as example data in README.md
   must be replaced by real sources (isystem API, Shopify customer account). */
(() => {
  const $ = s => document.querySelector(s), $$ = s => [...document.querySelectorAll(s)];

const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
const eur = n => n.toLocaleString('pt-PT',{minimumFractionDigits:2,maximumFractionDigits:2})+' €';
const esc = s => String(s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));

/* Catalogue. Categories and the iPhone list mirror isell.pt/pages/reparacoes.
   Prices: the iPhone row is isell.pt's live price list for iPhone 13; other
   models/categories scale from it and are illustrative until wired to isystem. */
let CATALOG = {
  Apple: {
    iPhone: ['iPhone 17 Pro Max','iPhone 17 Pro','iPhone 17 Air','iPhone 17','iPhone 16 Pro Max','iPhone 16 Pro','iPhone 16 Plus','iPhone 16','iPhone 16e','iPhone 15 Pro Max','iPhone 15 Pro','iPhone 15 Plus','iPhone 15','iPhone 14 Pro Max','iPhone 14 Pro','iPhone 14 Plus','iPhone 14','iPhone 13 Pro Max','iPhone 13 Pro','iPhone 13 Mini','iPhone 13','iPhone 12 Pro Max','iPhone 12 Pro','iPhone 12 Mini','iPhone 12','iPhone 11 Pro Max','iPhone 11 Pro','iPhone 11','iPhone SE 2022','iPhone SE 2020','iPhone XS Max','iPhone XS','iPhone XR','iPhone X'],
    iPad: ['iPad Pro 12.9" 5Gen – 2021','iPad Pro 11" 3Gen – 2021','iPad Air 10.9" 5Gen – 2022','iPad Air 10.9" 4Gen – 2020','iPad 10.2" 9Gen – 2021','iPad 10.2" 8Gen – 2020','iPad Mini 7.9" 5Gen – 2019'],
    MacBook: ['MacBook Air 13" 2022 A2681','MacBook Air 13" 2020 A2337','MacBook Pro 13" 2020 A2338','MacBook Pro 13" 2020 A2251','MacBook Air 13" 2018 a 2019 A1932','MacBook Pro 15" 2018 a 2019 A1990'],
    'Apple Watch': ['Apple Watch 8 45mm','Apple Watch 8 41mm','Apple Watch SE 2022 44mm','Apple Watch SE 2022 40mm','Apple Watch 7 45mm','Apple Watch 7 41mm','Apple Watch 6 44mm','Apple Watch 6 40mm'],
    iMac: ['iMac M3 (2023)','iMac M1 (2021)','iMac Pro (2017 – 2021)','iMac Retina (2012 – 2019)']
  },
  Samsung: {
    'Galaxy S': ['Galaxy S25 Ultra','Galaxy S25','Galaxy S24 Ultra','Galaxy S24','Galaxy S23 Ultra','Galaxy S23','Galaxy S22'],
    'Galaxy A': ['Samsung A55 5G A556','Samsung A54 5G A546','Samsung A35 5G A356','Samsung A25 5G A256','Samsung A16 5G A166','Samsung A15 4G A155 / A15 5G A156','Samsung A53 5G A536'],
    'Galaxy Z': ['Galaxy Z Fold6','Galaxy Z Flip6','Galaxy Z Fold5','Galaxy Z Flip5'],
    'Galaxy Tab': ['Galaxy Tab S9','Galaxy Tab S8','Galaxy Tab A9+']
  },
  Xiaomi: {
    Redmi: ['Redmi Note 13 Pro','Redmi Note 13','Redmi Note 12 Pro','Redmi Note 12','Redmi 13C'],
    Xiaomi: ['Xiaomi 14','Xiaomi 13T Pro','Xiaomi 13T','Xiaomi 13'],
    POCO: ['POCO F6','POCO X6 Pro','POCO X6','POCO M6 Pro']
  },
  PlayStation: {
    Consola: ['PS5 Pro','PS5 Slim','PS5','PS4 Pro','PS4 Slim','PS4'],
    Comando: ['DualSense Edge','DualSense','DualShock 4']
  },
  Xbox: {
    Consola: ['Xbox Series X','Xbox Series S','Xbox One X','Xbox One S'],
    Comando: ['Comando Xbox Series','Comando Xbox Elite Series 2','Comando Xbox One']
  },
  Nintendo: {
    Consola: ['Nintendo Switch 2','Nintendo Switch OLED','Nintendo Switch','Nintendo Switch Lite'],
    Comando: ['Joy-Con 2','Joy-Con','Nintendo Switch Pro Controller']
  },
  Lenovo: { 'Portátil': ['Lenovo Legion','Lenovo ThinkPad','Lenovo Yoga','Lenovo IdeaPad'] },
  HP: { 'Portátil': ['HP Omen','HP Victus','HP Envy','HP Pavilion','HP EliteBook','HP ProBook'] },
  Asus: { 'Portátil': ['Asus ROG','Asus TUF Gaming','Asus ZenBook','Asus VivoBook'] }
};
let REPAIRS = {
  iPhone: [['Ecrã',110,'v'],['Bateria',55,'v'],['Porta de carregamento',70],['Câmara',80],['Tampa traseira',80],['Coluna',60],['Microfone',70],['Auscultador',60],['Botão',80],['Carregamento wireless',80],['Flash',70],['Sensor de proximidade',70],['Vibrador',55],['Wi-Fi',60],['Chassi completo',120],['Limpeza de líquidos',35]],
  iPad: [['Ecrã',120,'v'],['Bateria',90,'v'],['Porta de carregamento',80],['Câmara',80],['Botão',70],['Limpeza de líquidos',45]],
  MacBook: [['Ecrã',290,'v'],['Bateria',160,'v'],['Teclado',180],['Top case',260],['Porta USB-C',140],['Limpeza de líquidos',90],['Recuperação de dados',129]],
  'Apple Watch': [['Ecrã',120,'v'],['Bateria',70,'v'],['Vidro traseiro',80],['Coroa digital',75]],
  iMac: [['Ecrã',350,'v'],['Disco SSD',150],['Fonte de alimentação',160],['Limpeza interna',60],['Recuperação de dados',129]],
  phone: [['Ecrã',95,'v'],['Bateria',55,'v'],['Porta de carregamento',60],['Câmara',70],['Tampa traseira',60],['Coluna',50],['Microfone',55],['Limpeza de líquidos',35]],
  tablet: [['Ecrã',130,'v'],['Bateria',80,'v'],['Porta de carregamento',70],['Limpeza de líquidos',45]],
  Consola: [['Porta HDMI',89],['Limpeza e pasta térmica',59],['Leitor de discos',99],['Fonte de alimentação',89],['Ventoinha',69],['Disco / SSD',79]],
  'Nintendo:Consola': [['Ecrã',79,'v'],['Bateria',59,'v'],['Conector USB-C',59],['Leitor de cartões de jogo',59],['Calhas dos Joy-Con',35],['Limpeza e pasta térmica',49]],
  Comando: [['Drift dos analógicos',39],['Bateria',29],['Botões e gatilhos',29],['Porta de carregamento',29],['Limpeza interna',19]],
  'Nintendo:Comando': [['Drift dos analógicos',25],['Bateria',25],['Botões',25],['Calhas de encaixe',25]],
  'Portátil': [['Ecrã',129,'v'],['Bateria',79,'v'],['Teclado',89],['Dobradiças',69],['Porta de carregamento',69],['Limpeza e pasta térmica',49],['Recuperação de dados',89],['Formatação e sistema',45]]
};
let VARIANTS = {'Ecrã':[['Compatível',1],['Original',1.6]],'Bateria':[['Compatível',1],['Original',1.45]]};
function repairSet(){ return REPAIRS[`${S.brand}:${S.series}`] || REPAIRS[S.series] || (/Tab/.test(S.series)?REPAIRS.tablet:REPAIRS.phone); }
const NO_LOCK=['Consola','Comando'];
const needsLock=()=>!NO_LOCK.includes(S.series);
function factor(){
  const m=S.model; let f=1;
  if(['Consola','Comando','Portátil'].includes(S.series)) return /Pro|Series X|Switch 2|Edge|Elite|Legion|ROG|Omen/.test(m)?1.15:1;
  if(S.series==='iPhone'){ const n=+(m.match(/iPhone (\d+)/)||[])[1]||0;
    f = n>=17?1.5 : n>=16?1.3 : n>=15?1.2 : n>=14?1.1 : n>=13?1 : n>=11?.9 : .8;
    if(/Pro Max|Plus/.test(m)) f*=1.18; else if(/Pro|Air/.test(m)) f*=1.1; else if(/Mini|SE|16e/.test(m)) f*=.92; }
  else if(/Ultra|Fold|Pro|12\.9/.test(m)) f=1.35; else if(/S2[45]|Flip|M3|2022/.test(m)) f=1.15;
  return f;
}
const round5 = n => Math.round(n/5)*5;
function priceOf(name,base,variant){ const v=(VARIANTS[name]||[]).find(x=>x[0]===variant); return round5(base*factor()*(v?v[1]:1)); }

/* ── Catálogo real da BD ──────────────────────────────────────────────────
   window.ISELL_DB é gerado server-side em reparacoes-proto.liquid a partir da
   coleção Shopify + metafields (marcas, categorias, modelos, avarias, preços).
   Quando existe, substitui CATALOG e passa a fonte de avarias/preços a ser a
   BD (REAL_MODELS) em vez dos dados de exemplo escalados por factor(). */
let REAL_MODELS = null;        // modelo → { tipo → [[variação, preçoCents], …] }
const REAL_TIMES = {};          // tipo → minutos (repair_time), quando numérico
(function(){
  const DB = window.ISELL_DB;
  if(!DB || !DB.index) return;
  const cat = {};
  DB.index.split('§').forEach(row=>{
    if(!row) return;
    const [b,c,m] = row.split('¦');
    if(!b||!c||!m) return;
    (cat[b] = cat[b]||{}); (cat[b][c] = cat[b][c]||[]);
    if(!cat[b][c].includes(m)) cat[b][c].push(m);
  });
  if(!Object.keys(cat).length) return;
  CATALOG = cat;
  const byModel = {};
  (DB.rows||'').split('§').forEach(row=>{
    if(!row) return;
    const p = row.split('¦');
    const m=p[0], t=p[1], vlabel=p[2]||'', cents=+p[3]||0;
    if(!m||!t) return;
    (byModel[m] = byModel[m]||{}); (byModel[m][t] = byModel[m][t]||[]);
    byModel[m][t].push([vlabel, cents]);
  });
  REAL_MODELS = byModel;
  (DB.times||'').split('§').forEach(row=>{
    if(!row) return;
    const [t, raw] = row.split('¦');
    if(!t) return;
    const mins = parseInt(String(raw||'').replace(/\D+/g,''),10);
    if(mins>0) REAL_TIMES[t] = mins;
  });
})();
/* Avarias + preços para o MODELO escolhido, a partir da BD (quando disponível).
   Rebuild de VARIANTS a cada chamada: as variações (qualidade) são por modelo. */
repairSet = function(){
  // A typed model outside the selected category has no quoted repairs.
  if(!(CATALOG[S.brand]?.[S.series]||[]).includes(S.model)) return [];
  if(REAL_MODELS){
    const types = REAL_MODELS[S.model] || {};
    VARIANTS = {};
    return Object.keys(types).map(t=>{
      const labelled = types[t].filter(x=>x[0]!=='').sort((a,b)=>a[1]-b[1]);
      if(labelled.length>1){
        VARIANTS[t] = labelled.map(x=>[x[0]]);
        return [t, labelled[0][1]/100, 'v'];
      }
      const only = labelled[0] || types[t][0] || ['',0];
      return [t, only[1]/100];
    });
  }
  return REPAIRS[`${S.brand}:${S.series}`] || REPAIRS[S.series] || (/Tab/.test(S.series)?REPAIRS.tablet:REPAIRS.phone);
};
function validateSelectedRepairs(){
  const available = new Map([...repairSet(), ['Outra avaria',0,'o']].map(r=>[r[0],r]));
  S.reps = new Map([...S.reps].flatMap(([name, selected])=>{
    const def=available.get(name); if(!def) return [];
    const variants=(VARIANTS[name]||[]).map(v=>v[0]);
    const variant=def[2]==='v' ? (variants.includes(selected?.variant)?selected.variant:variants[0]||'Compatível') : '';
    return [[name,{base:def[1],kind:def[2]||'',variant}]];
  }));
}
priceOf = function(name,base,variant){
  if(REAL_MODELS && REAL_MODELS[S.model] && REAL_MODELS[S.model][name]){
    const arr = REAL_MODELS[S.model][name];
    if(variant){ const hit = arr.find(x=>x[0]===variant); if(hit) return hit[1]/100; }
    return Math.min(...arr.map(x=>x[1]))/100;
  }
  const v=(VARIANTS[name]||[]).find(x=>x[0]===variant); return round5(base*factor()*(v?v[1]:1));
};

// Store IDs must come from the signed backend config. Never offer display-only
// fallback IDs: the collect endpoint only accepts active tbl_store IDs.
let STORES = [];
let STORE_CONFIG_READY = false;
const CP = {'2590':['Sobral de Monte Agraço','Rua dos Lusíadas'],'2500':['Caldas da Rainha',''],'2560':['Torres Vedras',''],'1050':['Lisboa',''],'1000':['Lisboa',''],'1100':['Lisboa',''],'4000':['Porto',''],'4200':['Porto',''],'3000':['Coimbra',''],'2400':['Leiria',''],'8000':['Faro',''],'2700':['Amadora',''],'2750':['Cascais','']};
let HOLIDAYS = ['2026-10-05','2026-11-01','2026-12-01','2026-12-08','2026-12-25','2027-01-01','2027-03-26','2027-03-28','2027-04-25','2027-05-01'];
let STORE_HOLIDAYS = [];
let OCCUPIED_STORE_SLOTS = {};
let STORE_EARLIEST_DATE = '', STORE_VISIBLE_DAYS = 10;
let STORE_DAY_PAGE = 0;
const PT_DAY = ['Domingo','Segunda','Terça','Quarta','Quinta','Sexta','Sábado'];
const PT_MON = ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'];
/* Example account for the login demo. Clearly a sample, not a real customer. */
const DEMO = {name:'Ana Ferreira (exemplo)', email:'ana.ferreira@exemplo.pt', tel:'912345678', nif:'123456789',
  jobs:[
    {ref:'22816',m:'PS5',kind:'console',status:'quote',created:'2026-09-30',updated:'2026-10-02',items:[['Porta HDMI',90]],deliv:'home'},
    {ref:'22814',m:'iPhone 15 Pro',kind:'phone',status:'repair',created:'2026-09-28',updated:'2026-10-01',items:[['Ecrã · Original',290]],deliv:'home'},
    {ref:'22812',m:'iPhone 13',kind:'phone',status:'ready',created:'2026-09-19',updated:'2026-09-23',items:[['Bateria · Compatível',55]],deliv:'store',store:'Loja Lisboa'},
    {ref:'22811',m:'MacBook Air 13" 2020',kind:'laptop',status:'qc',created:'2026-09-17',updated:'2026-09-23',items:[['Teclado',180]],deliv:'store',store:'Loja Caldas da Rainha'},
    {ref:'22809',m:'Galaxy S24',kind:'phone',status:'delivered',created:'2026-09-08',updated:'2026-09-14',items:[['Ecrã · Compatível',110],['Bateria · Compatível',65]],deliv:'home'},
    {ref:'22806',m:'iPhone 13',kind:'phone',status:'refused',created:'2026-09-05',updated:'2026-09-11',items:[['Câmara',80]],deliv:'store',store:'Rua Santos Bernardes'},
    {ref:'22805',m:'DualSense',kind:'console',status:'delivered',created:'2026-09-04',updated:'2026-09-11',items:[['Drift dos analógicos',40]],deliv:'home'}],
  picks:[
    {ref:'22816',m:'PS5',status:'scheduled',date:'2026-10-06',dir:'in',track:'8402 1931 5523',addr:'Rua dos Lusíadas, 29 · Sobral de Monte Agraço'},
    {ref:'22814',m:'iPhone 15 Pro',status:'atstore',date:'2026-09-29',dir:'in',track:'8402 1931 4410',addr:'Rua dos Lusíadas, 29 · Sobral de Monte Agraço'},
    {ref:'22809',m:'Galaxy S24',status:'returned',date:'2026-09-14',dir:'out',track:'8402 1930 9987',addr:'Rua dos Lusíadas, 29 · Sobral de Monte Agraço'},
    {ref:'22805',m:'DualSense',status:'returned',date:'2026-09-11',dir:'out',track:'8402 1930 9120',addr:'Av. Miguel Bombarda, 110, 2.º · Lisboa'}],
  addrs:[{label:'Casa', cp:'2590-011', street:'Rua dos Lusíadas', door:'29', city:'Sobral de Monte Agraço'},{label:'Trabalho', cp:'1050-167', street:'Av. Miguel Bombarda', door:'110, 2.º', city:'Lisboa'}]};

const S = {step:0, brand:'', series:'', model:'', reps:new Map(), desc:'', lock:'pin', pin:'', pattern:[],
  deliv:'', cp:'', street:'', door:'', city:'', date:'', dateLabel:'',
  store:'', sday:'', hour:'', name:'', email:'', tel:'', nif:'', terms:false, user:null, accountVerified:false};

const iso = d => d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');
const isBiz = d => d.getDay()%6!==0 && !HOLIDAYS.includes(iso(d));
function addBiz(d,n){const x=new Date(d);while(n>0){x.setDate(x.getDate()+1);if(isBiz(x))n--;}return x}
/* The visible band: viewport minus the sticky page header and the fixed mobile order bar. */
/* No modal mobile o contentor de scroll é o #view-flow (position:fixed), não a janela. */
function flowScroller(){ const vf=document.getElementById('view-flow'); return (vf && document.body.classList.contains('in-flow') && getComputedStyle(vf).position==='fixed') ? vf : null; }
function visibleBand(){
  const sc=flowScroller();
  let top = sc ? sc.getBoundingClientRect().top : 0;
  let bottom = sc ? sc.getBoundingClientRect().bottom : innerHeight;
  const head=document.querySelector('#view-flow:not([hidden]) .flow-head');
  if(head) top=head.getBoundingClientRect().bottom;
  const bar=document.getElementById('mbar');
  if(bar && document.body.classList.contains('in-flow') && getComputedStyle(bar).display!=='none'){ const r=bar.getBoundingClientRect(); if(r.top<bottom) bottom=r.top; }
  return {top, bottom, h:bottom-top};
}
/* Centre the element the customer is about to act on. Taller than the band? Align its
   top just under the header instead, so its beginning is never cut off. */
function scrollToEl(el){
  if(!el) return;
  const sc=flowScroller(), r=el.getBoundingClientRect(), b=visibleBand();
  const cur = sc ? sc.scrollTop : scrollY;
  const delta = r.height > b.h-32 ? (r.top - b.top - 16) : (r.top - b.top - (b.h - r.height)/2);
  (sc||window).scrollTo({top:Math.max(0, cur + delta), behavior:RM?'auto':'smooth'});
}
/* Page-level moves (a new step) start from the top of the stepper. */
function alignTop(el){
  if(!el) return;
  const sc=flowScroller(), b=visibleBand(), cur = sc ? sc.scrollTop : scrollY;
  (sc||window).scrollTo({top:Math.max(0, cur + (el.getBoundingClientRect().top - b.top - 12)), behavior:RM?'auto':'smooth'});
}
function reveal(id, scroll=true){ const el=$(id); if(!el.hidden) return; el.hidden=false; el.classList.remove('reveal'); void el.offsetWidth; el.classList.add('reveal'); if(scroll) setTimeout(()=>scrollToEl(el),60); }
function toast(t){ const el=$('#toast'); el.textContent=t; el.classList.add('show'); clearTimeout(toast.t); toast.t=setTimeout(()=>el.classList.remove('show'),2400); }
function setPressed(c,btn){ c.querySelectorAll(':scope > [aria-pressed]').forEach(b=>b.setAttribute('aria-pressed', b===btn?'true':'false')); }

/* ---------- step 1 ---------- */
$('#brands').innerHTML = Object.keys(CATALOG).map(b=>`<button type="button" class="tile" data-b="${b}" aria-pressed="false">${b}</button>`).join('');
$('#brands').addEventListener('click', e=>{
  const t=e.target.closest('.tile'); if(!t) return; setPressed($('#brands'),t);
  if(S.brand!==t.dataset.b){ S.brand=t.dataset.b; S.series=''; resetModel(); $('#b-model').hidden=true; }
  $('#series').innerHTML = Object.keys(CATALOG[S.brand]).map(s=>`<button type="button" class="tile" data-s="${s}" aria-pressed="false">${s}</button>`).join('');
  reveal('#b-series'); update();
  const cats=Object.keys(CATALOG[S.brand]), want=(pendingSeries&&cats.includes(pendingSeries))?pendingSeries:(cats.length===1?cats[0]:null);
  pendingSeries=null; if(want && S.series!==want) setTimeout(()=>{ const st=$(`#series .tile[data-s="${want}"]`); st&&st.click(); },0);
});
$('#series').addEventListener('click', e=>{
  const t=e.target.closest('.tile'); if(!t) return; setPressed($('#series'),t);
  if(S.series!==t.dataset.s){ S.series=t.dataset.s; resetModel(); }
  reveal('#b-model'); setTimeout(()=>$('#model').focus({preventScroll:true}), RM?0:350); update();
});
function resetModel(){ S.model=''; S.reps.clear(); modelInput.value=''; modelSheetInput.value=''; modelList.hidden=true; modelSheetList.innerHTML=''; renderModelPicked(); $('#b-issue').hidden=true; $('#b-other').hidden=true; }
let act=-1;
const modelOptions = q => (CATALOG[S.brand]?.[S.series]||[]).filter(m=>!q.trim()||m.toLowerCase().includes(q.trim().toLowerCase()));
const modelInput=$('#model'), modelList=$('#model-list');
const modelSheet=$('#model-sheet'), modelSheetInput=$('#model-sheet-input'), modelSheetList=$('#model-sheet-list');
const mobileModelPicker=()=>document.body.classList.contains('in-flow') && matchMedia('(max-width:960px)').matches;
let modelSheetInitialValue='';
function renderList(input=modelInput,list=modelList){
  const q=input.value, opts=modelOptions(q);
  act = opts.length ? Math.min(Math.max(act,0),opts.length-1) : -1;
  let h = opts.map((m,i)=>`<div class="opt${i===act?' act':''}" role="option" data-m="${esc(m)}">${esc(m)}</div>`).join('');
  const qq=q.trim();
  if(qq.length>=2 && !opts.some(o=>o.toLowerCase()===qq.toLowerCase())) h += `<div class="opt" role="option" data-m="${esc(qq)}">Usar "${esc(qq)}"<small>não está na lista</small></div>`;
  list.innerHTML = h || `<div class="opt none">Escreve o modelo</div>`; list.hidden=false; input.setAttribute('aria-expanded','true');
}
function syncModelSheetViewport(){
  if(modelSheet.hidden) return;
  const viewport=window.visualViewport;
  /* iOS changes the visual viewport while the keyboard animates, but keeps the
     fixed sheet anchored to the layout viewport. Use the document height as
     the stable reference so the sheet recovers after the keyboard disappears. */
  const layoutHeight=Math.max(document.documentElement?.clientHeight||0,innerHeight);
  const visibleHeight=Math.min(layoutHeight,viewport?.height||layoutHeight);
  const visibleTop=viewport?.offsetTop||0;
  const keyboardOpen=layoutHeight-visibleHeight>140;
  /* The iOS visual viewport stops above the keyboard's accessory/toolbar area.
     If we end the sheet at visualHeight, that strip reveals the page behind it.
     Keep the sheet extended to the layout bottom; the opaque keyboard naturally
     covers the portion underneath it and there is no exposed gap. */
  const sheetHeight=Math.max(0,Math.min(layoutHeight-visibleTop,keyboardOpen?layoutHeight-visibleTop:Math.min(layoutHeight*.8,680)));
  const sheetTop=keyboardOpen ? visibleTop : layoutHeight-sheetHeight;
  modelSheet.style.setProperty('--model-sheet-top',`${Math.round(Math.max(0,sheetTop))}px`);
  modelSheet.style.setProperty('--model-sheet-height',`${Math.round(sheetHeight)}px`);
}
let modelSheetViewportTimers=[];
function scheduleModelSheetViewport(){
  modelSheetViewportTimers.forEach(clearTimeout); modelSheetViewportTimers=[];
  [0,50,150,300,600].forEach(ms=>modelSheetViewportTimers.push(setTimeout(syncModelSheetViewport,ms)));
}
function openModelSheet(){
  if(!mobileModelPicker()||!modelSheet.hidden) return;
  modelSheetInitialValue=modelInput.value;
  modelSheetInput.value=modelSheetInitialValue;
  modelList.hidden=true; modelInput.setAttribute('aria-expanded','false');
  modelSheet.hidden=false; $('#model-sheet-backdrop').hidden=false;
  document.body.classList.add('model-sheet-open');
  act=-1; renderList(modelSheetInput,modelSheetList); modelSheetList.scrollTop=0;
  syncModelSheetViewport();
  scheduleModelSheetViewport();
  modelInput.blur(); modelSheetInput.focus({preventScroll:true});
}
function closeModelSheet(commit=false){
  if(modelSheet.hidden) return;
  /* Closing the mobile picker cancels an unfinished query. Only a picked
     option is committed; otherwise restore the value that was there on open. */
  if(!commit) modelInput.value=modelSheetInitialValue;
  modelSheetInput.blur();
  modelSheet.hidden=true; $('#model-sheet-backdrop').hidden=true;
  document.body.classList.remove('model-sheet-open');
  modelSheetInput.setAttribute('aria-expanded','false');
  scheduleModelSheetViewport();
}
function modelKeydown(e,input,list){
  const items=[...list.querySelectorAll('.opt[data-m]')];
  if(e.key==='ArrowDown'){e.preventDefault();act=Math.min(act+1,items.length-1);renderList(input,list)}
  else if(e.key==='ArrowUp'){e.preventDefault();act=Math.max(act-1,0);renderList(input,list)}
  else if(e.key==='Enter'){e.preventDefault();const it=items[Math.max(act,0)];if(it)pickModel(it.dataset.m)}
  else if(e.key==='Escape'){if(list===modelSheetList)closeModelSheet();else{list.hidden=true;input.setAttribute('aria-expanded','false')}}
}
modelInput.addEventListener('focus',()=>{act=-1;if(mobileModelPicker())openModelSheet();else renderList()});
modelInput.addEventListener('click',()=>{if(mobileModelPicker())openModelSheet();else if(modelList.hidden){act=-1;renderList()}});
modelInput.addEventListener('input',()=>{act=0;if(mobileModelPicker())openModelSheet();else{renderList();modelList.scrollTop=0}});
modelInput.addEventListener('keydown',e=>modelKeydown(e,modelInput,modelList));
modelSheetInput.addEventListener('input',()=>{act=0;renderList(modelSheetInput,modelSheetList);modelSheetList.scrollTop=0});
modelSheetInput.addEventListener('keydown',e=>modelKeydown(e,modelSheetInput,modelSheetList));
[modelList,modelSheetList].forEach(list=>list.addEventListener('click',e=>{const o=e.target.closest('.opt[data-m]');if(o)pickModel(o.dataset.m)}));
$('#model-sheet-backdrop').addEventListener('click',closeModelSheet);
$('#model-sheet-close').addEventListener('click',closeModelSheet);
window.addEventListener('resize',()=>{if(!mobileModelPicker())closeModelSheet();else scheduleModelSheetViewport()},{passive:true});
window.visualViewport?.addEventListener('resize',scheduleModelSheetViewport,{passive:true});
window.visualViewport?.addEventListener('scroll',scheduleModelSheetViewport,{passive:true});
document.addEventListener('click',e=>{if(!modelSheet.hidden)return;if(!e.target.closest('#model-picker')){modelList.hidden=true;modelInput.setAttribute('aria-expanded','false')}});
let pendingSeries=null, pendingRepair=null;
function pickModel(m){ closeModelSheet(true); S.model=m; S.reps.clear(); modelInput.value=''; modelSheetInput.value=''; modelList.hidden=true; modelInput.setAttribute('aria-expanded','false'); renderModelPicked(); renderRepairs(); reveal('#b-issue');
  if(pendingRepair){ const want=pendingRepair; pendingRepair=null; const hit=repairSet().find(r=>want.includes(r[0])); if(hit) toggleRep(hit[0]); }
  update(); }
function renderModelPicked(){
  const has=!!S.model; $('#model-picker').hidden=has; $('#model-picked').hidden=!has;
  if(has) $('#model-picked').innerHTML=`<div class="picked"><div><b>${esc(S.model)}</b><small>${S.brand} · ${S.series}</small></div><button type="button" class="linkbtn" id="model-change">Alterar</button></div>`;
}
$('#model-picked').addEventListener('click',e=>{ if(e.target.id==='model-change'){ resetModel(); $('#model').focus(); update(); } });

function renderRepairs(){
  const list=[...repairSet(),['Outra avaria',0,'o']], P=priced();
  $('#repairs').innerHTML = list.map(([n,b,k])=>{
    const sel=S.reps.get(n), on=!!sel, vars=k==='v'?VARIANTS[n]:null;
    let price = k==='o' ? '<small></small>Diagnóstico grátis' : vars ? (on?eur(priceOf(n,b,sel.variant)):`<small>desde</small>${eur(priceOf(n,b,'Compatível'))}`) : eur(priceOf(n,b));
    return `<div class="rep" role="button" tabindex="0" data-n="${esc(n)}" aria-pressed="${on}">
      <div class="top"><span class="box"></span><span class="nm">${esc(n)}</span><span class="pr">${price}</span></div>
      ${vars?`<div class="vars"${on?'':' hidden'}>${vars.map(([v])=>`<button type="button" class="var" data-v="${v}" aria-pressed="${on&&sel.variant===v}">${v} · ${eur(priceOf(n,b,v))}</button>`).join('')}</div>`:''}
    </div>`; }).join('');
}
function toggleRep(n){
  const def=[...repairSet(),['Outra avaria',0,'o']].find(r=>r[0]===n); if(!def) return;
  if(S.reps.has(n)) S.reps.delete(n); else S.reps.set(n,{base:def[1],kind:def[2]||'',variant:def[2]==='v'?((VARIANTS[n]&&VARIANTS[n][0]&&VARIANTS[n][0][0])||'Compatível'):''});
  renderRepairs();
  const other=S.reps.has('Outra avaria');
  if(other && $('#b-other').hidden){ reveal('#b-other',false); setTimeout(()=>{scrollToEl($('#b-other'));$('#desc').focus({preventScroll:true})},120); }
  if(!other) $('#b-other').hidden=true;
  bumpTotals(); if(S.reps.size) revealLockOnce(); update();
}
$('#repairs').addEventListener('click',e=>{
  const v=e.target.closest('.var');
  if(v){ e.stopPropagation(); const n=v.closest('.rep').dataset.n; S.reps.get(n).variant=v.dataset.v; renderRepairs(); bumpTotals(); update(); return; }
  const r=e.target.closest('.rep'); if(r) toggleRep(r.dataset.n);
});
$('#repairs').addEventListener('keydown',e=>{ const r=e.target.closest('.rep'); if(r&&e.target===r&&(e.key==='Enter'||e.key===' ')){e.preventDefault();toggleRep(r.dataset.n)} });
function bumpTotals(){ ['#s-total','#mb-total'].forEach(s=>{const el=$(s);el.classList.remove('bump');void el.offsetWidth;el.classList.add('bump')}); }
function lines(){ return [...S.reps].map(([n,r])=> r.kind==='o' ? {n, sub:'', p:0, other:true} : {n, sub:r.variant||'', p:priceOf(n,r.base,r.variant)}); }
/* Multi-repair offer: from 3 priced repairs, 20% off every one except the most expensive. */
const DISC_MIN=3, DISC=0.20;
function priced(){
  const L=lines(), paid=L.filter(l=>!l.other&&l.p>0);
  const on=paid.length>=DISC_MIN;
  let top=null; if(on){ top=paid.reduce((a,b)=>b.p>a.p?b:a); }
  L.forEach(l=>{ l.was=l.p; l.now=(on&&!l.other&&l.p>0&&l!==top)?Math.round(l.p*(1-DISC)*100)/100:l.p; l.off=l.now<l.was; });
  const gross=L.reduce((a,l)=>a+l.was,0), net=L.reduce((a,l)=>a+l.now,0);
  return {L, on, gross, net, saving:Math.round((gross-net)*100)/100, paidCount:paid.length};
}
const total = () => priced().net;
const totalLabel = (P=priced()) => {
  const hasQuote=P.L.some(l=>l.other);
  if(hasQuote && P.L.every(l=>l.other)) return 'A orçamentar';
  return eur(P.net)+(hasQuote?' +':'');
};

$('#desc').addEventListener('input',e=>{ S.desc=e.target.value; $('#desc-count').textContent=S.desc.length+'/600'; update(); });
let lockShown=false;
function revealLockOnce(){}

$('#lockmode').addEventListener('click',e=>{
  const b=e.target.closest('button'); if(!b) return; setPressed($('#lockmode'),b); S.lock=b.dataset.m;
  $('#lock-pin').hidden=S.lock!=='pin'; $('#lock-pattern').hidden=S.lock!=='pattern'; $('#lock-note').hidden=S.lock==='none';
  if(S.lock==='pin') $('#pin').focus(); update();
});
$('#pin').addEventListener('input',e=>{S.pin=e.target.value;update()});
$('#pin-eye').addEventListener('click',()=>{const p=$('#pin');p.type=p.type==='password'?'text':'password';$('#pin-eye').setAttribute('aria-label',p.type==='password'?'Mostrar código':'Esconder código')});
const PTS=[];for(let r=0;r<3;r++)for(let c=0;c<3;c++)PTS.push({x:33+c*60,y:33+r*60});
function drawPad(cur){
  let h='';
  for(let i=1;i<S.pattern.length;i++){const a=PTS[S.pattern[i-1]],b=PTS[S.pattern[i]];h+=`<line x1="${a.x}" y1="${a.y}" x2="${b.x}" y2="${b.y}"/>`}
  if(cur&&S.pattern.length){const a=PTS[S.pattern.at(-1)];h+=`<line x1="${a.x}" y1="${a.y}" x2="${cur.x}" y2="${cur.y}" style="opacity:.35"/>`}
  PTS.forEach((p,i)=>h+=`<circle class="dot${S.pattern.includes(i)?' on':''}" cx="${p.x}" cy="${p.y}" r="${S.pattern.includes(i)?11:9}"/>`);
  $('#padsvg').innerHTML=h;
}
let drawing=false;
const padPoint=e=>{const r=$('#pad').getBoundingClientRect();return{x:(e.clientX-r.left)*186/r.width,y:(e.clientY-r.top)*186/r.height}};
const hit=p=>PTS.forEach((q,i)=>{if(!S.pattern.includes(i)&&Math.hypot(q.x-p.x,q.y-p.y)<22)S.pattern.push(i)});
$('#pad').addEventListener('pointerdown',e=>{drawing=true;S.pattern=[];$('#pad').setPointerCapture(e.pointerId);const p=padPoint(e);hit(p);drawPad(p)});
$('#pad').addEventListener('pointermove',e=>{if(!drawing)return;const p=padPoint(e);hit(p);drawPad(p)});
const endPad=()=>{if(!drawing)return;drawing=false;drawPad();
  const h=$('#pat-help'); if(S.pattern.length<4){h.textContent='Liga pelo menos 4 pontos.';h.style.color='var(--danger)'} else {h.textContent=`Padrão com ${S.pattern.length} pontos guardado.`;h.style.color='var(--brand-2)'}
  $('#pat-clear').hidden=!S.pattern.length; update()};
$('#pad').addEventListener('pointerup',endPad);$('#pad').addEventListener('pointercancel',endPad);
$('#pat-clear').addEventListener('click',()=>{S.pattern=[];drawPad();$('#pat-help').textContent='Desenha o padrão arrastando o dedo de ponto em ponto.';$('#pat-help').style.color='';$('#pat-clear').hidden=true;update()});
drawPad();

/* Authentication is exclusively handled by Shopify customer accounts. */
/* Guarda o estado do wizard (equipamento + avarias + desbloqueio) antes de ir
   para o login Shopify, para o utilizador retomar exatamente onde estava. */
function saveRepairResume(){
  try{ sessionStorage.setItem('isell_repair_resume', JSON.stringify({
    t:Date.now(), brand:S.brand, series:S.series, model:S.model,
    reps:[...S.reps], desc:S.desc, lock:S.lock, pin:S.pin, pattern:S.pattern
  })); }catch(e){}
}
/* routes.storefront_login_url já inclui return_to para esta página. O estado
   do wizard é retomado de sessionStorage depois de a Shopify regressar. */
/* Restaura o estado guardado por saveRepairResume (até 15 min). */
function restoreRepairResume(){
  try{
    var raw=sessionStorage.getItem('isell_repair_resume'); if(!raw) return false;
    sessionStorage.removeItem('isell_repair_resume');
    var s=JSON.parse(raw);
    if(!s || (Date.now()-(s.t||0))>900000 || !s.model) return false;
    S.brand=s.brand||''; S.series=s.series||''; S.model=s.model||'';
    S.reps=new Map(Array.isArray(s.reps)?s.reps:[]);
    validateSelectedRepairs();
    S.desc=s.desc||''; S.lock=s.lock||'pin'; S.pin=s.pin||''; S.pattern=Array.isArray(s.pattern)?s.pattern:[];
    return true;
  }catch(e){ return false; }
}
function redirectToShopifyLogin(){
  const link=$('#shopify-login');
  const base=(window.ISELL&&window.ISELL.loginUrl)||(link&&link.getAttribute('href'));
  if(base){ saveRepairResume(); window.location.assign(base); return true; }
  toast('Não foi possível abrir a autenticação Shopify. Tenta novamente.');
  link&&link.focus({preventScroll:true});
  return false;
}
function signedIn(u,isNew){
  S.user=u; const parts=u.name.split(/\s+/);
  $('#acc-av').textContent=(parts[0][0]+(parts[1]?parts[1][0]:'')).toUpperCase();
  $('#acc-hi').textContent=isNew?`Conta criada, ${parts[0]}`:`Olá, ${parts[0]}`;
  $('#acc-msg').textContent=isNew?'Já preenchemos o nome e o email nos teus dados.':'Os teus dados ficam preenchidos. Podes usar uma morada guardada.';
  $('#acc-forms').hidden=true; $('#acc-done').hidden=false; $('#acc').classList.add('signed');
  setField('name',u.name); setField('email',u.email); if(u.tel) setField('tel',u.tel); if(u.nif) setField('nif',u.nif);
  renderSavedAddresses();
  if(isNew) toast('Conta criada.');
  afterAuth(); update(); if(S.step==='A') go(1);
}
function savedAddresses(){
  const liquidAddresses=window.ISELL&&window.ISELL.customer&&window.ISELL.customer.addresses;
  return S.user&&Array.isArray(S.user.addrs)&&S.user.addrs.length ? S.user.addrs : (Array.isArray(liquidAddresses)?liquidAddresses:[]);
}
let selectedPickupAddressIndex=null;
function renderSavedAddresses(){
  const addresses=savedAddresses();
  $('#addrs').innerHTML=addresses.map((a,i)=>{
    const street=[a.street,a.door].filter(Boolean).join(', ');
    const place=[a.cp,a.city].filter(Boolean).join(' ');
    return `<button type="button" class="addr" data-i="${i}" aria-pressed="${selectedPickupAddressIndex===i}"><span><b>${esc(street||place)}</b>${street&&place?`<small>${esc(place)}</small>`:''}</span><span class="tag">Usar</span></button>`;
  }).join('');
  $('#addrs').hidden = !addresses.length || S.deliv!=='home' || !S.date;
}
function signOut(){ window.location.assign((window.ISELL && window.ISELL.logoutUrl) || '/account/logout'); }
$('#acc-out')?.addEventListener('click',signOut);
function setField(id,val){ const el=$('#'+id); el.value=val; el.dispatchEvent(new Event('input')); el.classList.add('filled'); setTimeout(()=>el.classList.remove('filled'),1600); }
function fillContact(){ setField('name',S.user.name); setField('email',S.user.email); setField('tel',S.user.tel); setField('nif',S.user.nif); }
function selectSavedAddress(index){
  const a=savedAddresses()[index]; if(!a) return false;
  selectedPickupAddressIndex=index;
  setPressed($('#addrs'),$('#addrs').querySelector(`[data-i="${index}"]`));
  $('#b-addr').hidden=false;
  ['street','door'].forEach(k=>setField(k,a[k]||''));
  S.city=''; setField('city',''); setField('cp',a.cp||'');
  if(a.city){
    clearTimeout(cpTimer);
    $('#city').classList.remove('skel');
    $('#cp-side').innerHTML='';
    setField('city',a.city);
  }
  return true;
}
function clearSavedAddressSelection(e){
  if(e.isTrusted && selectedPickupAddressIndex!==null){
    selectedPickupAddressIndex=null;
    setPressed($('#addrs'),null);
  }
}
$('#addrs').addEventListener('click',e=>{
  const b=e.target.closest('.addr'); if(!b) return; setPressed($('#addrs'),b);
  if(!selectSavedAddress(+b.dataset.i)) return;
  setTimeout(()=>scrollToEl($('#b-addr')),80);
});

/* ---------- step 2 ---------- */
$$('.dcard').forEach(c=>c.addEventListener('click',()=>{
  $$('.dcard').forEach(x=>x.setAttribute('aria-checked',x===c?'true':'false'));
  S.deliv=c.dataset.d; $('#b-home').hidden=S.deliv!=='home'; $('#b-store').hidden=S.deliv!=='store';
  renderSavedAddresses();
  const el=$(S.deliv==='home'?'#b-home':'#b-store'); el.classList.remove('reveal'); void el.offsetWidth; el.classList.add('reveal');
  setTimeout(()=>scrollToEl(el),60);
  update();
}));

function buildDates(){
  const today=new Date(); today.setHours(12,0,0,0);
  const first=addBiz(today,2); const d=new Date(first); d.setDate(d.getDate()-1);
  const out=[], skipped=[];
  while(out.length<6){ d.setDate(d.getDate()+1);
    if(d.getDay()%6===0) continue;
    if(HOLIDAYS.includes(iso(d))){ skipped.push(`${d.getDate()} ${PT_MON[d.getMonth()]}`); continue; }
    out.push(`<button type="button" class="date" data-d="${iso(d)}" data-l="${PT_DAY[d.getDay()]}, ${d.getDate()} ${PT_MON[d.getMonth()]}" aria-pressed="false"><small>${PT_DAY[d.getDay()].slice(0,3)}</small><b>${String(d.getDate()).padStart(2,'0')}</b><em>${PT_MON[d.getMonth()]}</em></button>`);
  }
  $('#dates').innerHTML=out.join('');
  dateHelp = '';
  $('#date-help').textContent=dateHelp;
}
let dateHelp=''; buildDates();
$('#dates').addEventListener('click',e=>{ const b=e.target.closest('.date'); if(!b) return; setPressed($('#dates'),b); S.date=b.dataset.d; S.dateLabel=b.dataset.l;
  renderSavedAddresses();
  if($('#b-addr').hidden){ reveal('#b-addr'); setTimeout(()=>{ if(!S.cp) $('#cp').focus({preventScroll:true}) },RM?0:450); }
  if(S.deliv==='home' && !S.cp && !S.street && !S.door && !S.city) selectSavedAddress(0);
  update(); });

let cpTimer;
$('#cp').addEventListener('input',e=>{
  clearSavedAddressSelection(e);
  let v=e.target.value.replace(/\D/g,'').slice(0,7); if(v.length>4) v=v.slice(0,4)+'-'+v.slice(4);
  e.target.value=v; S.cp=v; $('#e-cp').hidden=true; e.target.classList.remove('bad');
  clearTimeout(cpTimer); $('#cp-side').innerHTML='';
  if(/^\d{4}-\d{3}$/.test(v)){
    $('#cp-side').innerHTML='<span class="spin" aria-label="A procurar"></span>';
    const city=$('#city'); city.classList.add('skel'); city.value='A procurar…';
    cpTimer=setTimeout(()=>{
      const h=CP[v.slice(0,4)]; city.classList.remove('skel');
      if(h){ S.city=h[0]; city.value=S.city; city.classList.add('good');
        if(h[1]&&!S.street){S.street=h[1];$('#street').value=S.street}
        $('#cp-side').innerHTML='<svg class="ok" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><path d="M5 12l5 5 9-10"/></svg>';
        if(!S.street) $('#street').focus({preventScroll:true}); else if(!S.door) $('#door').focus({preventScroll:true});
      } else { city.value=S.city||''; city.focus({preventScroll:true}); toast('Não encontrámos a localidade, escreve-a tu.'); }
      update();
    },750);
  }
  update();
});
$('#cp').addEventListener('blur',()=>{ if(S.cp&&!/^\d{4}-\d{3}$/.test(S.cp)){ $('#e-cp').hidden=false; $('#cp').classList.add('bad'); } });
['street','door','city'].forEach(id=>$('#'+id).addEventListener('input',e=>{ clearSavedAddressSelection(e); S[id]=e.target.value.trim(); e.target.classList.remove('bad'); if(id==='city')e.target.classList.remove('good');
  update(); }));

$('#stores').innerHTML = STORES.map(s=>`<button type="button" class="store" role="radio" aria-checked="false" data-s="${s.id}"><span class="pin"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 21s-7-6.1-7-11a7 7 0 0114 0c0 4.9-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/></svg></span><span><b>${esc(s.name)}</b><small>${esc(s.addr)}</small></span><span class="meta">${esc(s.hours).replace(' · ','<br>')}</span></button>`).join('');
function storeDays(){
  const st=STORES.find(s=>s.id===S.store); if(!st) return [];
  const out=[], today=new Date(), d=STORE_EARLIEST_DATE ? new Date(STORE_EARLIEST_DATE+'T12:00') : new Date();
  today.setHours(12,0,0,0); d.setHours(12,0,0,0);
  for(let i=0;i<STORE_VISIBLE_DAYS;i++){ const x=new Date(d); x.setDate(d.getDate()+i); const dow=x.getDay();
    const key=iso(x);
    const offset=Math.round((x-today)/86400000);
    if(offset<0) continue;
    if(STORE_HOLIDAYS.includes(key)||dow===0||(dow===6&&!st.sat)) continue;
    // Today only while at least one slot is still ahead (last slot 18:00, Saturday 12:00).
    if(offset===0){ const n=new Date(), nowH=n.getHours()+n.getMinutes()/60, last=(dow===6?((st.hrs&&st.hrs.satClose)||13):((st.hrs&&st.hrs.wkClose)||19))-1; if(last<=nowH+.5) continue; }
    out.push({k:key, l:offset===0?'Hoje':offset===1?'Amanhã':`${PT_DAY[dow].slice(0,3)} ${x.getDate()} ${PT_MON[x.getMonth()]}`, sat:dow===6, today:offset===0}); }
  return out;
}
function renderStoreDays(){ const days=storeDays(); if(!days.find(d=>d.k===S.sday)) S.sday=days[0]?.k||'';
  const pages=Math.ceil(days.length/7); STORE_DAY_PAGE=Math.max(0,Math.min(STORE_DAY_PAGE,pages-1));
  const shown=days.slice(STORE_DAY_PAGE*7,(STORE_DAY_PAGE+1)*7);
  $('#storeday').innerHTML=(days.length===0?'<p class="muted">Sem datas disponíveis neste intervalo.</p>':'')
    +(STORE_DAY_PAGE>0?'<button type="button" class="chip" data-page="prev" aria-label="Datas anteriores">‹</button>':'')
    +shown.map(d=>`<button type="button" class="chip" data-k="${d.k}" aria-pressed="${d.k===S.sday}">${d.l}</button>`).join('')
    +(STORE_DAY_PAGE<pages-1?'<button type="button" class="chip" data-page="next" aria-label="Mais datas">›</button>':''); renderHours(); }
function renderHours(){
  const day=storeDays().find(d=>d.k===S.sday)||{};
  if(!day.k){ S.hour=''; $('#hours').innerHTML='<p class="muted">Sem datas disponíveis. Escolhe outra loja.</p>'; return; }
  const st=STORES.find(s=>s.id===S.store), H=(st&&st.hrs)||{wkOpen:9,wkClose:19,satOpen:10,satClose:13};
  const open=day.sat?H.satOpen:H.wkOpen, close=day.sat?H.satClose:H.wkClose;
  const n=new Date(), nowH=n.getHours()+n.getMinutes()/60, slots=[];
  for(let h=open; h<=close-1; h++){
    if(day.today && h<=nowH+.5) continue;            // hora já passada
    const hour=(''+h).padStart(2,'0')+':00';
    if((OCCUPIED_STORE_SLOTS[String(S.store)]||[]).includes(S.sday+' '+hour)) continue;
    slots.push(hour);
  }
  if(!slots.includes(S.hour)) S.hour='';
  $('#hours').innerHTML = slots.length
    ? slots.map(h=>`<button type="button" class="hour" data-h="${h}" aria-pressed="${S.hour===h}">${h}</button>`).join('')
    : `<p class="muted" style="margin:0;font-size:13px">Sem horas disponíveis neste dia. Escolhe outro dia.</p>`;
}
$('#stores').addEventListener('click',e=>{ const b=e.target.closest('.store'); if(!b) return;
  if(!STORE_CONFIG_READY || !STORES.some(s=>s.id===b.dataset.s)){ toast('As lojas ainda estão a carregar. Tenta novamente dentro de alguns segundos.'); return; }
  $$('#stores .store').forEach(x=>x.setAttribute('aria-checked',x===b?'true':'false')); S.store=b.dataset.s; STORE_DAY_PAGE=0; renderStoreDays(); reveal('#b-hours'); update(); });
$('#storeday').addEventListener('click',e=>{const b=e.target.closest('.chip');if(!b)return;
  if(b.dataset.page){ STORE_DAY_PAGE+=b.dataset.page==='next'?1:-1; S.sday=storeDays()[STORE_DAY_PAGE*7]?.k||''; S.hour=''; renderStoreDays(); update(); return; }
  S.sday=b.dataset.k;setPressed($('#storeday'),b);renderHours();update()});
$('#hours').addEventListener('click',e=>{const b=e.target.closest('.hour');if(!b||b.disabled)return;setPressed($('#hours'),b);S.hour=b.dataset.h;update();setTimeout(()=>scrollToEl($('#nav')),120)});

/* ---------- step 3 ---------- */
/* Strict Portuguese NIF checksum — used only to auto-fill from a Shopify tax id. */
const ptNifStrict=v=>{ if(!/^[1235689]\d{8}$/.test(v)&&!/^(45|70|71|72|74|75|77|79|90|91|98|99)\d{7}$/.test(v)) return false;
  let s=0; for(let i=0;i<8;i++) s+=+v[i]*(9-i); const c=11-(s%11); return (c>=10?0:c)===+v[8]; };
/* Field validator: NIF is optional and accepts any tax id (PT or foreign).
   Valid when empty, or at least 6 characters once filled. */
const nifOk=v=>{ const t=String(v||'').trim(); return t.length===0 || t.length>=6; };
function portugueseTaxId(value){
  const raw=String(value||'').trim();
  if(!/^(?:PT[\s.-]*)?[\d\s.-]+$/i.test(raw)) return '';
  const digits=raw.replace(/^PT[\s.-]*/i,'').replace(/\D/g,'');
  return ptNifStrict(digits)?digits:'';
}
const emailOk=v=>/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(v);
const nameOk=v=>v.split(/\s+/).filter(w=>w.length>1).length>=2;
function normalizePortugalPhone(value){
  let digits=String(value??'').replace(/\D/g,'');
  if(digits.startsWith('00351')&&digits.length>9)digits=digits.slice(5);
  else if(digits.startsWith('351')&&digits.length>9)digits=digits.slice(3);
  return digits.slice(0,9);
}
const PHONE_COUNTRIES=[
  ['351','🇵🇹','Portugal'],['34','🇪🇸','Espanha'],['55','🇧🇷','Brasil'],
  ['244','🇦🇴','Angola'],['258','🇲🇿','Moçambique'],['238','🇨🇻','Cabo Verde'],
  ['245','🇬🇼','Guiné-Bissau'],['239','🇸🇹','São Tomé e Príncipe'],
  ['33','🇫🇷','França'],['41','🇨🇭','Suíça'],['352','🇱🇺','Luxemburgo'],
  ['44','🇬🇧','Reino Unido'],['49','🇩🇪','Alemanha'],['1','🇺🇸','EUA / Canadá'],
  ['39','🇮🇹','Itália'],['31','🇳🇱','Países Baixos'],['32','🇧🇪','Bélgica'],
  ['43','🇦🇹','Áustria'],['353','🇮🇪','Irlanda'],['30','🇬🇷','Grécia'],
  ['48','🇵🇱','Polónia'],['420','🇨🇿','Chéquia'],['421','🇸🇰','Eslováquia'],
  ['36','🇭🇺','Hungria'],['40','🇷🇴','Roménia'],['359','🇧🇬','Bulgária'],
  ['385','🇭🇷','Croácia'],['386','🇸🇮','Eslovénia'],['45','🇩🇰','Dinamarca'],
  ['46','🇸🇪','Suécia'],['47','🇳🇴','Noruega'],['358','🇫🇮','Finlândia'],
  ['354','🇮🇸','Islândia'],['372','🇪🇪','Estónia'],['371','🇱🇻','Letónia'],
  ['370','🇱🇹','Lituânia'],['356','🇲🇹','Malta'],['357','🇨🇾','Chipre'],
  ['376','🇦🇩','Andorra'],['377','🇲🇨','Mónaco'],['380','🇺🇦','Ucrânia'],
  ['90','🇹🇷','Turquia'],['212','🇲🇦','Marrocos'],['213','🇩🇿','Argélia'],
  ['216','🇹🇳','Tunísia'],['20','🇪🇬','Egito'],['27','🇿🇦','África do Sul'],
  ['52','🇲🇽','México'],['54','🇦🇷','Argentina'],['56','🇨🇱','Chile'],
  ['57','🇨🇴','Colômbia'],['58','🇻🇪','Venezuela'],['86','🇨🇳','China'],
  ['91','🇮🇳','Índia'],['81','🇯🇵','Japão'],['971','🇦🇪','Emirados Árabes Unidos'],
  ['972','🇮🇱','Israel'],['61','🇦🇺','Austrália'],['64','🇳🇿','Nova Zelândia']
];
const PHONE_OTHER=['','🌐','Outro indicativo'];
let phoneCountry=PHONE_COUNTRIES[0];
const phonePrefix=()=>phoneCountry===PHONE_OTHER?$('#tel-custom-code').value.replace(/\D/g,'').slice(0,3):phoneCountry[0];
const phoneE164=()=>{const national=$('#tel').value.replace(/\D/g,'');const code=phonePrefix();return code&&national?'+'+code+national:''};
function validPhoneNumber(value,code,national){
  if(code==='351'&&!/^[29]\d{8}$/.test(national))return false;
  return /^\+[1-9]\d{8,14}$/.test(value) && national.length>=6;
}
const telOk=v=>validPhoneNumber(v,phonePrefix(),$('#tel').value.replace(/\D/g,''));
function splitInternationalPhone(value){
  const raw=String(value||'').trim();
  if(!/^(?:\+|00)\d/.test(raw))return null;
  const digits=raw.replace(/\D/g,'').replace(/^00/,'');
  const country=[...PHONE_COUNTRIES].sort((a,b)=>b[0].length-a[0].length).find(p=>digits.startsWith(p[0])&&digits.length>p[0].length);
  const code=country?country[0]:digits.slice(0,3);
  return {country:country||PHONE_OTHER,code,national:digits.slice(code.length)};
}
function renderPhoneCountry(){
  const code=phonePrefix(), other=phoneCountry===PHONE_OTHER;
  $('#tel-flag').textContent=phoneCountry[1];
  $('#tel-code').textContent=code?'+'+code:'+…';
  $('#tel-country').setAttribute('aria-label','Indicativo do país: '+phoneCountry[2]+(code?' +'+code:''));
  $('#tel').placeholder=code==='351'?'912 345 678':'Número nacional';
  $('#tel-custom').hidden=!other;
  $$('#tel-options .tel-option').forEach(b=>b.setAttribute('aria-selected',String(b.dataset.phoneIndex===(other?'other':String(PHONE_COUNTRIES.indexOf(phoneCountry))))));
}
function choosePhoneCountry(country,customCode='',emit=true){
  phoneCountry=country;
  $('#tel-custom-code').value=customCode;
  renderPhoneCountry();
  if(emit)$('#tel').dispatchEvent(new Event('input'));
}
function formatPhoneInput(el){
  const explicit=splitInternationalPhone(el.value);
  if(explicit){choosePhoneCountry(explicit.country,explicit.country===PHONE_OTHER?explicit.code:'',false);el.value=explicit.national}
  const code=phonePrefix(), max=Math.max(0,15-code.length);
  const national=(code==='351'?normalizePortugalPhone(el.value):el.value.replace(/\D/g,'').slice(0,max));
  el.value=code==='351'?national.replace(/(\d{3})(?=\d)/g,'$1 ').trim():national;
}
$('#tel-options').innerHTML=PHONE_COUNTRIES.map((p,i)=>`<button type="button" class="tel-option" role="option" data-phone-index="${i}" aria-selected="false"><span aria-hidden="true">${p[1]}</span><span class="tel-option-name">${p[2]}</span><span class="tel-option-code">+${p[0]}</span></button>`).join('')
  +'<button type="button" class="tel-option" role="option" data-phone-index="other" aria-selected="false"><span aria-hidden="true">🌐</span><span class="tel-option-name">Outro indicativo</span></button>';
renderPhoneCountry();
function closePhoneMenu(){ $('#tel-menu').hidden=true;$('#tel-country').setAttribute('aria-expanded','false') }
$('#tel-country').addEventListener('click',()=>{
  const open=$('#tel-menu').hidden;
  $('#tel-menu').hidden=!open;$('#tel-country').setAttribute('aria-expanded',String(open));
  if(open){$('#tel-search').value='';$$('#tel-options .tel-option').forEach(b=>b.hidden=false);$('#tel-search').focus()}
});
$('#tel-search').addEventListener('input',e=>{
  const q=e.target.value.toLocaleLowerCase('pt-PT').normalize('NFD').replace(/[\u0300-\u036f]/g,'');
  $$('#tel-options .tel-option').forEach(b=>{const label=b.textContent.toLocaleLowerCase('pt-PT').normalize('NFD').replace(/[\u0300-\u036f]/g,'');b.hidden=!label.includes(q)});
});
$('#tel-options').addEventListener('click',e=>{
  const b=e.target.closest('.tel-option');if(!b)return;
  const other=b.dataset.phoneIndex==='other';
  choosePhoneCountry(other?PHONE_OTHER:PHONE_COUNTRIES[+b.dataset.phoneIndex],other?$('#tel-custom-code').value:'');
  if(other)$('#tel-custom-code').focus();else{closePhoneMenu();$('#tel').focus()}
});
$('#tel-custom-code').addEventListener('input',e=>{e.target.value=e.target.value.replace(/\D/g,'').slice(0,3);renderPhoneCountry();$('#tel').dispatchEvent(new Event('input'))});
document.addEventListener('click',e=>{if(!e.target.closest('.tel-wrap'))closePhoneMenu()});
$('#tel-menu').addEventListener('keydown',e=>{if(e.key==='Escape'){closePhoneMenu();$('#tel-country').focus()}});
const DOMAINS={'gmial.com':'gmail.com','gmai.com':'gmail.com','gmail.co':'gmail.com','hotmial.com':'hotmail.com','hotmail.co':'hotmail.com','outlok.com':'outlook.com','sapo.p':'sapo.pt','iclod.com':'icloud.com'};
const okIcon='<svg class="ok" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><path d="M5 12l5 5 9-10"/></svg>';
function field(id,ok,fmt){
  const el=$('#'+id);
  el.addEventListener('input',()=>{ if(fmt)fmt(el); S[id]=id==='tel'?phoneE164():(id==='name'||id==='email')?el.value.trim():el.value.replace(/\s/g,'');
    const good=ok(S[id]); el.classList.toggle('good',good); if(good){el.classList.remove('bad');$('#e-'+id).hidden=true}
    const side=$('#'+id+'-side'); if(side) side.innerHTML=good?okIcon:'';
    if(id==='email'){ const dom=S.email.split('@')[1], sug=DOMAINS[dom?.toLowerCase()]; $('#email-sug').hidden=!sug;
      if(sug) $('#email-sug').innerHTML=`Querias dizer <button type="button" class="linkbtn" id="fixmail">${esc(S.email.split('@')[0])}@${sug}</button>?`; }
    update(); });
  el.addEventListener('blur',()=>{ const bad=!!S[id]&&!ok(S[id]); el.classList.toggle('bad',bad); $('#e-'+id).hidden=!bad; });
}
field('name',nameOk);
field('email',emailOk);
field('tel',telOk,formatPhoneInput);
field('nif',nifOk);
$('#email-sug').addEventListener('click',e=>{if(e.target.id==='fixmail'){$('#email').value=e.target.textContent;$('#email').dispatchEvent(new Event('input'));$('#email-sug').hidden=true;toast('Email corrigido')}});
$('#terms').addEventListener('change',e=>{S.terms=e.target.checked;$('#c-terms').classList.remove('bad');$('#e-terms').hidden=true;update()});

/* ---------- validation ---------- */
const issueOk=()=> S.reps.size>0 && (!S.reps.has('Outra avaria') || S.desc.trim().length>=10);
const lockOk=()=> S.lock==='none'||(S.lock==='pin'&&S.pin.trim())||(S.lock==='pattern'&&S.pattern.length>=4);
function missing(step){
  const m=[];
  if(step===0){ if(!S.brand)m.push('a marca'); else if(!S.series)m.push('o tipo'); else if(!S.model)m.push('o modelo');
    else if(!S.reps.size)m.push('a avaria'); else if(!issueOk())m.push('descrever a avaria'); }
  if(step==='L'){ if(!lockOk()) m.push(S.lock==='pattern'?'o padrão':'o código'); }
  if(step==='A'){ if(!S.user && !S.accountVerified)m.push('criar conta ou entrar'); }
  if(step===1){ if(!S.deliv)m.push('a forma de entrega');
    else if(S.deliv==='home'){ if(!/^\d{4}-\d{3}$/.test(S.cp))m.push('o código postal'); if(!S.street)m.push('a morada'); if(!S.city)m.push('a localidade'); if(!S.date)m.push('a data'); }
    else { if(!S.store)m.push('a loja'); else if(!S.hour)m.push('a hora'); } }
  if(step===2){ if(!nameOk(S.name))m.push('o nome'); if(!emailOk(S.email))m.push('o email'); if(!telOk(S.tel))m.push('o telefone'); if(!nifOk(S.nif))m.push('o NIF'); if(!S.terms)m.push('aceitar os termos'); }
  return m;
}
const listPT=a=>a.length<=1?a.join(''):a.slice(0,-1).join(', ')+' e '+a.at(-1);
function showErrors(step){
  if(step===0){
    if(!S.brand) return scrollToEl($('#brands'));
    if(!S.series) return scrollToEl($('#b-series'));
    if(!S.model){ scrollToEl($('#b-model')); $('#model').focus({preventScroll:true}); return; }
    if(!S.reps.size){ scrollToEl($('#b-issue')); toast('Escolhe pelo menos uma avaria.'); return; }
    if(!issueOk()){ $('#e-desc').hidden=false; $('#desc').classList.add('bad'); scrollToEl($('#b-other')); $('#desc').focus({preventScroll:true}); return; }
  }
  if(step==='L'){
    if(S.lock==='pin'){ $('#e-pin').hidden=false; $('#pin').classList.add('bad'); scrollToEl($('#b-lock')); $('#pin').focus({preventScroll:true}); return; }
    $('#pat-help').textContent='Desenha o padrão com pelo menos 4 pontos.'; $('#pat-help').style.color='var(--danger)'; scrollToEl($('#b-lock'));
  }
  if(step==='A'){ scrollToEl($('#shopify-login')); return; }
  if(step===1){
    if(!S.deliv){ $('#e-deliv').textContent='Escolhe entre recolha em casa ou entrega numa loja.'; $('#e-deliv').hidden=false; return scrollToEl($('.choice')); }
    if(S.deliv==='home'){ if(!S.date){ $('#date-help').style.color='var(--danger)'; $('#date-help').textContent='Escolhe primeiro o dia da recolha.'; return scrollToEl($('#b-date')); }
      const order=[['cp',!/^\d{4}-\d{3}$/.test(S.cp)],['street',!S.street],['city',!S.city]];
      order.forEach(([id,b])=>$('#'+id).classList.toggle('bad',b)); const f=order.find(o=>o[1]);
      if(f){ scrollToEl($('#'+f[0])); $('#'+f[0]).focus({preventScroll:true}); return; }
      }
    else { $('#e-deliv').textContent=!S.store?'Escolhe a loja onde vais entregar o equipamento.':'Escolhe a hora prevista de entrega.'; $('#e-deliv').hidden=false; scrollToEl($(!S.store?'#b-store':'#b-hours')); }
  }
  if(step===2){ let first=null;
    [['name',!nameOk(S.name)],['email',!emailOk(S.email)],['tel',!telOk(S.tel)],['nif',!nifOk(S.nif)]].forEach(([id,b])=>{$('#'+id).classList.toggle('bad',b);$('#e-'+id).hidden=!b;if(b&&!first)first=id});
    if(!S.terms){ $('#c-terms').classList.add('bad'); $('#e-terms').hidden=false; if(!first)first='c-terms'; }
    if(first){ scrollToEl($('#'+first)); if(first!=='c-terms') $('#'+first).focus({preventScroll:true}); }
  }
}

/* ---------- summary & review ---------- */
const storeObj=()=>STORES.find(s=>s.id===S.store);
const sdayLabel=()=>{ if(!S.sday) return ''; const d=new Date(S.sday+'T12:00'), t=new Date(); t.setHours(12,0,0,0); const diff=Math.round((d-t)/864e5);
  return diff===0?'Hoje':diff===1?'Amanhã':`${PT_DAY[d.getDay()]}, ${d.getDate()} ${PT_MON[d.getMonth()]}`; };
const lockText=()=>S.lock==='none'?'Sem bloqueio':S.lock==='pattern'?`Padrão · ${S.pattern.length} pontos`:`Código · ${S.pin.length} caracteres`;
const fmtTel=t=>/^\+351[29]\d{8}$/.test(t)?'+351 '+t.slice(4).replace(/(\d{3})(?=\d)/g,'$1 '):t;
const contactNumberForBooking=t=>/^\+351[29]\d{8}$/.test(t)?t.slice(4):t;
const ICON={dev:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="6" y="2" width="12" height="20" rx="3"/><path d="M11 18h2"/></svg>',
 tool:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14.7 6.3a4 4 0 00-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 005.4-5.4l-2.5 2.5-2.5-.6-.6-2.5z"/></svg>',
 truck:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h11v10H3zM14 9h4l3 3v4h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',
 user:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="8" r="4"/><path d="M4 21c1-4 4.5-6 8-6s7 2 8 6"/></svg>',
 clock:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
 shield:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z"/></svg>',
 check:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12l5 5 9-10"/></svg>'};
function delivSummary(){
  if(S.deliv==='home') return {t:'Recolha em casa · NACEX', l:[S.street&&`${S.street}${S.door?', '+S.door:''}`,[S.cp,S.city].filter(Boolean).join(' '),S.dateLabel].filter(Boolean)};
  if(S.deliv==='store'){ const s=storeObj(); return {t:'Entrega em loja', l:[s?.name, s?.addr, S.hour&&`${sdayLabel()} às ${S.hour}`].filter(Boolean)}; }
  return null;
}
const GIFT='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M5 12v9h14v-9M12 8S10.5 3 8 3.5 7 7 12 8zm0 0s1.5-5 4-4.5S17 7 12 8z"/></svg>';
function offerHTML(P){
  if(P.on) return {won:true, h:`${GIFT}<span><b>Desconto multi-reparação aplicado.</b> Poupas ${eur(P.saving)} com 20% em todas as reparações exceto a mais cara.</span>`};
  const need=DISC_MIN-P.paidCount;
  if(P.paidCount>=1 && need>0) return {won:false, h:`${GIFT}<span>Junta mais <b>${need} ${need>1?'reparações':'reparação'}</b> e tens <b>20% de desconto</b> em todas exceto a mais cara.</span>`};
  return null;
}
function paintOffer(el,o){ el.hidden=!o; if(o){ el.innerHTML=o.h; el.classList.toggle('won',o.won); } }
function renderSummary(){
  $('#s-dev').textContent = S.model || 'Equipamento por escolher';
  $('#s-devsub').textContent = S.model ? `${S.brand} · ${S.series}` : 'Marca, tipo e modelo';
  const P=priced(), L=P.L;
  const pr=l=> l.other?'A orçamentar' : eur(l.was);
  $('#s-lines').innerHTML = L.length ? L.map(l=>`<div class="sl"><dt>${esc(l.n)}${l.sub?`<small>${esc(l.sub)}</small>`:''}</dt><dd>${pr(l)}</dd></div>`).join('')
    + (P.on?`<div class="sl save"><dt>Desconto exclusivo online</dt><dd>−${eur(P.saving)}</dd></div>`:'')
    + (S.deliv?`<div class="sl"><dt>${S.deliv==='home'?'Recolha e devolução':'Entrega em loja'}</dt><dd style="color:var(--brand)">Grátis</dd></div>`:'')
    : `<p class="sempty">Escolhe as avarias para veres o preço.</p>`;
  const quoteOnly=L.length>0 && L.every(l=>l.other), totalText=totalLabel(P);
  $('#s-total').closest('.stotal').classList.toggle('quote-only',quoteOnly);
  $('#s-total').textContent = totalText;
  $('#s-total').classList.toggle('quote-total',quoteOnly);
  $('#s-old').hidden=!P.on; $('#s-old').textContent=eur(P.gross);
  var _mbt=$('#mb-total'); if(_mbt){ _mbt.textContent = L.length ? totalText : '0,00 €'; _mbt.classList.toggle('quote-total',quoteOnly); var _mbo=$('#mb-old'); if(_mbo){ _mbo.hidden=!P.on; _mbo.textContent=eur(P.gross); } }
  const d=delivSummary();
  $('#s-meta').innerHTML = (d?`<div>${ICON.truck}<span>${esc(d.t)}${d.l.length?' · '+esc(d.l.at(-1)):''}</span></div>`:'')
    + (L.length&&S.deliv==='store'?`<div>${ICON.clock}<span>Tempo estimado de reparação: <b>${fmtDur(L)}</b></span></div>`:'')
    + `<div>${ICON.shield}<span>Garantia de 3 anos nas peças substituídas</span></div>`;
}
function renderReview(){
  const d=delivSummary(), g=(icon,title,body)=>`<section class="rgroup"><div class="rgh"><span class="gi">${ICON[icon]}</span><b>${title}</b></div><dl class="rgb">${body}</dl></section>`;
  const row=(k,v)=>`<div class="rl"><dt>${esc(k)}</dt><dd>${v}</dd></div>`;
  $('#review').innerHTML =
    g('truck', d.t, d.l.map((x,i)=>row(i===d.l.length-1?(S.deliv==='home'?'Data':'Quando'):(i===0?(S.deliv==='home'?'Morada':'Loja'):(S.deliv==='home'?'Localidade':'Morada')), esc(x))).join(''))
  + g('user','Contacto', row('Nome',esc(S.name))+row('Email',esc(S.email))+row('Telefone',fmtTel(S.tel))+row('NIF',esc(S.nif||'—')));
}
$('#review').addEventListener('click',e=>{const b=e.target.closest('[data-go]');if(b)go(b.dataset.go==='L'?'L':+b.dataset.go)});

/* ---------- nav ---------- */
const STEP_NAMES={0:'Equipamento',L:'Desbloqueio',A:'Conta',1:'Entrega',2:'Os teus dados',3:'Confirmar'};
const ORDER=[0,'L','A',1,2,3];
function update(){
  const m=missing(S.step), last=S.step===3;
  [$('#next-btn'),$('#mb-next')].forEach(b=>{ b.setAttribute('aria-disabled', m.length?'true':'false'); const bl=b.querySelector('.bl'); if(bl) bl.textContent=last?'Agendar reparação':'Continuar'; b.classList.toggle('green',last); });
  const shown=m.filter(x=>x!=='criar conta ou entrar'&&x!=='aceitar os termos');
  $('#prev').style.visibility = S.step===0?'hidden':'visible';
  $('#nav').hidden = S.step>=4; $('#mbar').style.display = S.step>=4?'none':'';
  const _nrep = lines().length;
  $('#mb-sub').textContent = _nrep ? (_nrep+' '+(_nrep>1?'reparações':'reparação')+' · toca para ver') : 'Toca para ver o resumo';
  if(S.deliv) $('#e-deliv').hidden=true;
  if(S.date){ $('#date-help').style.color=''; $('#date-help').textContent=dateHelp; }
  if(issueOk()){ $('#e-desc').hidden=true; $('#desc').classList.remove('bad'); }
  if(S.pin.trim()){ $('#e-pin').hidden=true; $('#pin').classList.remove('bad'); }
  $('#data-sub').textContent = S.user ? 'Preenchemos com os dados da tua conta. Confirma ou altera o que precisares.' : 'Usamos estes contactos para te enviar o orçamento e o ponto de situação.';
  updateProgress();
  renderSummary();
}
/* Thin progress bar under the flow title — fills as the step advances. */
function updateProgress(){
  const fp=$('#flow-progress'); if(!fp) return;
  const ord=order(), idx=ord.indexOf(S.step);
  // Fill to 100% one step early: the "Os teus dados" step (second to last)
  // already shows a full bar and the final review step just holds at 100%.
  const pct = idx<0 ? 0 : Math.min(100, Math.round((idx+1)/(ord.length-1)*100));
  fp.style.setProperty('--flow-p', pct+'%');
  fp.setAttribute('aria-valuenow', pct);
}
const HEADS={A:['Entra ou cria conta','Assim acompanhas a reparação e recebes o orçamento para aprovar.'],L:['Só mais um detalhe','Com o código conseguimos testar tudo antes e depois da reparação.'],0:['Configurar pedido','Escolhe o equipamento e as avarias e vê o preço na hora. Sem compromisso.'],
  1:['Como nos fazes chegar o equipamento?','Recolhemos em casa sem custos, ou passas numa das nossas três lojas.'],
  2:['Quase lá','Só precisamos de saber como te contactar.'],
  3:['Confere e confirma','Tudo certo? Agenda e enviamos a confirmação por email.']};
function go(step){
  const fwd = ORDER.indexOf(step) > ORDER.indexOf(S.step) || step===4;
  const cur=$(`[data-panel="${S.step}"]`), nxt=$(`[data-panel="${step}"]`);
  cur.hidden=true; nxt.hidden=false; nxt.classList.remove('enter','rise'); void nxt.offsetWidth; nxt.classList.add(fwd?'enter':'rise');
  S.step=step; if(step===3) renderReview(); document.body.classList.toggle('on-review', step===3);
  document.body.classList.toggle('on-booking-success', step===4);
  if(step===4){
    // The final submit is only reachable after all drawers are closed. Clear
    // any theme scroll lock left behind by the single-page hash navigation.
    document.body.classList.remove('overflow-hidden','overflow-hidden-mobile','overflow-hidden-tablet','overflow-hidden-desktop');
    if(document.body.style.overflow==='hidden') document.body.style.removeProperty('overflow');
  }
  if(HEADS[step]){ $('#title').textContent=HEADS[step][0]; $('#lead').textContent=HEADS[step][1]; }
  if(step==='A' && (S.user || S.accountVerified)){
    $('#acc-forms').hidden=true; $('#acc-done').hidden=false;
    if(!S.user){ $('#acc-av').textContent='✓'; $('#acc-hi').textContent='Conta Shopify confirmada'; $('#acc-msg').textContent='Confirma os teus contactos no passo dos dados.'; }
  }
  update();
  setTimeout(()=>focusNext(step, fwd), RM?0:380);
}
/* The first control still waiting for an answer in a step: inputs first, then choice groups. */
function nextTarget(step){
  const empty = sel => [...document.querySelectorAll(sel)].find(i=>!i.closest('[hidden]') && !i.value.trim());
  if(step===0) return !S.brand?$('#brands .tile'):!S.series?$('#series .tile'):!S.model?$('#model'):(!S.reps.size?$('#repairs .rep'):(S.reps.has('Outra avaria')&&S.desc.trim().length<10?$('#desc'):null));
  if(step==='L') return S.lock==='pin'&&!S.pin.trim()?$('#pin'):S.lock==='pattern'&&S.pattern.length<4?$('#pad'):null;
  if(step==='A') return S.user || S.accountVerified ? null : $('#shopify-login');
  if(step===1){
    if(!S.deliv) return $('.dcard');
    if(S.deliv==='home') return !S.date?$('#dates .date'):empty('#b-addr input');
    return !S.store?$('#stores .store'):(!S.hour?$('#hours .hour:not(:disabled)'):null);
  }
  if(step===2) return empty('#name,#email,#tel') || (!S.terms?$('#terms'):null);
  if(step===3) return null;
  return null;
}
function focusNext(step, fwd){
  const el = fwd ? nextTarget(step) : null;
  if(!el){ alignTop(S.step===4?$('#done-title'):$('#title')); return; }
  // Centre the field itself (with its label), not the whole block it sits in.
  scrollToEl(el.closest('.f') || el);
  el.focus({preventScroll:true});
  if(el.select && el.value) el.select();
}
const order=()=>ORDER.filter(x=>(x!=='L'||needsLock()) && (x!=='A'||(!S.user && !S.accountVerified)));
document.addEventListener('focusin',e=>{
  const el=e.target;
  if(!el.matches || !el.matches('input:not([type=checkbox]):not([type=radio]),textarea,select')) return;
  if(view!=='flow' || !el.closest('#form')) return;          // only the booking steps re-centre; elsewhere the page stays put
  setTimeout(()=>{
    const r=el.getBoundingClientRect(), b=visibleBand(), mid=b.top+b.h/2, c=r.top+r.height/2;
    if(Math.abs(c-mid) > b.h*0.12) scrollToEl(el.closest('.f') || el);
  }, 40);
});
function next(){ if(missing(S.step).length){ showErrors(S.step); return; } if(S.step!==3) return go(order()[order().indexOf(S.step)+1]); submit(); }
$('#next-btn').addEventListener('click',next); $('#mb-next').addEventListener('click',next);
/* Action bar mobile: abrir/fechar o resumo (bottom-sheet que reutiliza o .summary). */
(function(){
  const trigger=document.getElementById('mbar-summary'), bd=document.getElementById('mbar-backdrop'), nextBtn=document.getElementById('mb-next');
  function setOpen(o){ document.body.classList.toggle('mbar-open',o); if(bd) bd.hidden=!o; if(trigger) trigger.setAttribute('aria-expanded',o?'true':'false'); }
  if(trigger) trigger.addEventListener('click',function(){ setOpen(!document.body.classList.contains('mbar-open')); });
  if(bd) bd.addEventListener('click',function(){ setOpen(false); });
  if(nextBtn) nextBtn.addEventListener('click',function(){ setOpen(false); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&document.body.classList.contains('mbar-open')) setOpen(false); });
})();
$('#prev').addEventListener('click',()=>{const o=order(), i=o.indexOf(S.step); if(i>0) go(o[i-1]);});

function submit(){
  const btns=[$('#next-btn'),$('#mb-next')], orig=btns.map(b=>b.innerHTML);
  btns.forEach(b=>{ b.setAttribute('aria-disabled','true'); b.innerHTML='<span class="spin" style="border-color:rgba(255,255,255,.35);border-top-color:#fff"></span> A agendar…'; });
  setTimeout(()=>{
    lastRef=nextRef(); $('#ref').textContent='#'+lastRef;
    const first=S.name.split(/\s+/)[0];
    $('#done-title').textContent=`Está agendado, ${first}`;
    if(S.deliv==='home'){
      $('#done-sub').textContent=`A NACEX passa em ${S.street}${S.door?', '+S.door:''} na ${S.dateLabel.toLowerCase()}. Total estimado ${eur(total())}. Enviámos a confirmação para ${S.email}.`;
      $('#next').innerHTML='<div><b>Prepara o equipamento</b><p>Desativa o "Encontrar" e faz uma cópia de segurança. O estafeta leva a embalagem.</p></div><div><b>Recolha</b><p>Recebes um SMS com a janela exata na véspera.</p></div><div><b>Orçamento</b><p>Diagnóstico no dia útil em que chega. Só reparamos depois de aprovares.</p></div>';
    } else {
      $('#done-sub').textContent=`Esperamos-te na ${storeObj().name}, ${sdayLabel().toLowerCase()} às ${S.hour}. Total estimado ${eur(total())}. Enviámos a confirmação para ${S.email}.`;
      $('#next').innerHTML='<div><b>Traz o equipamento</b><p>Com o carregador, se a avaria for de carga ou bateria. Mostra a referência ao balcão.</p></div><div><b>Diagnóstico</b><p>Muitas reparações ficam prontas no mesmo dia.</p></div><div><b>Orçamento</b><p>Só reparamos depois de aprovares o valor final.</p></div>';
    }
    btns.forEach((b,i)=>b.innerHTML=orig[i]);
    go(4); afterBooking(); $('#title').textContent='Reparação agendada'; $('#lead').textContent='Guarda a referência. É com ela que acompanhas o pedido.';
  },1400);
}
$('#restart').addEventListener('click',()=>location.reload());
/* ================= page sections ================= */
// Bench time per intervention, in minutes. Illustrative until it comes from isystem
// (the live page already shows one per repair, e.g. "Troca de ecrã · 1 hora").
const DUR={'Ecrã':60,'Bateria':45,'Porta de carregamento':60,'Câmara':60,'Tampa traseira':120,'Coluna':45,'Microfone':60,'Auscultador':45,'Botão':60,'Carregamento wireless':90,'Flash':60,'Sensor de proximidade':60,'Vibrador':45,'Wi-Fi':90,'Chassi completo':180,'Limpeza de líquidos':120,'Teclado':180,'Top case':240,'Porta USB-C':120,'Vidro traseiro':90,'Coroa digital':60,'Disco SSD':90,'Fonte de alimentação':90,'Limpeza interna':60,'Porta HDMI':120,'Limpeza e pasta térmica':60,'Leitor de discos':90,'Ventoinha':60,'Disco / SSD':60,'Conector USB-C':60,'Leitor de cartões de jogo':60,'Calhas dos Joy-Con':45,'Drift dos analógicos':45,'Botões e gatilhos':45,'Botões':30,'Calhas de encaixe':30,'Dobradiças':120,'Formatação e sistema':120,'Recuperação de dados':240};
function fmtDur(L){
  if(L.some(l=>l.other)) return 'após diagnóstico';
  const m=L.reduce((a,l)=>a+(REAL_TIMES[l.n]||DUR[l.n]||60),0);
  if(m<60) return m+' min';
  const h=Math.floor(m/60), r=m%60;
  return h+(h>1?' horas':' hora')+(r?` e ${r} min`:'');
}

/* Two views in one document: the base page and the "Nova reparação" page.
   A bare #nova-reparacao hash so the browser's Back button returns to the base page. */
const FLOW_HASH='#nova-reparacao', ACC_HASH='#minhas-reparacoes';
let view='';
// O login pelo cabeçalho (desktop ou móvel) também deve retomar o formulário.
document.addEventListener('click', e => {
  const link=e.target.closest('a[href*="/customer_authentication/login"]');
  if(link && view==='flow' && S.model) saveRepairResume();
}, true);
function showView(v){
  if(v===view) return; view=v;
  if(v!=='flow') closeModelSheet();
  $('#view-home').hidden = v!=='home'; $('#view-account').hidden = v!=='account'; $('#view-flow').hidden = v!=='flow';
  const siteTop=$('#site-top'); if(siteTop) siteTop.hidden = v==='flow';
  $('#site-foot').hidden = v==='flow';
  document.body.classList.toggle('in-flow', v==='flow');
  window.scrollTo({top:0,left:0,behavior:'instant'});
}
function route(){ const h=location.hash; if(h===ACC_HASH){ window.location.replace(portalUrl('rep')); return; } showView(h===FLOW_HASH?'flow':/\/pages\/(?:historico|meus-processos)\/?$/.test(location.pathname)?'account':'home'); }
function navTo(h){ if(location.hash!==h) history.pushState(null,'',h||(location.pathname+location.search)); }
addEventListener('hashchange', route);
addEventListener('popstate', route);
function openFlow(then){
  navTo(FLOW_HASH); showView('flow');
  setTimeout(()=>{ if(then) then(); else { const sec=$('#orcamento'), b=visibleBand(); window.scrollTo({top:Math.max(0, scrollY + sec.getBoundingClientRect().top - b.top - 16), left:0, behavior:'instant'}); const t=nextTarget(S.step); if(t) t.focus({preventScroll:true}); } }, 60);
}
function startNewFlow(){
  // A fresh quote must not reopen an unfinished step left in this tab.
  try{ sessionStorage.removeItem('isell_repair_resume'); }catch(e){}
  selectedPickupAddressIndex=null;
  Object.assign(S,{brand:'',series:'',model:'',reps:new Map(),desc:'',lock:'pin',pin:'',pattern:[],
    deliv:'',cp:'',street:'',door:'',city:'',date:'',dateLabel:'',store:'',sday:'',hour:'',terms:false});
  pendingSeries=null; pendingRepair=null;
  $$('#brands .tile').forEach(b=>b.setAttribute('aria-pressed','false'));
  $('#series').innerHTML=''; $('#b-series').hidden=true; $('#b-model').hidden=true;
  $('#model').value=''; $('#model-list').hidden=true; $('#model').setAttribute('aria-expanded','false');
  renderModelPicked(); $('#b-issue').hidden=true; $('#b-other').hidden=true;
  $('#desc').value=''; $('#desc-count').textContent='0/600'; $('#pin').value='';
  setPressed($('#lockmode'),$('#lockmode [data-m="pin"]'));
  $('#lock-pin').hidden=false; $('#lock-pattern').hidden=true; $('#lock-note').hidden=false;
  drawPad(); $('#pat-clear').hidden=true;
  $('#pat-help').textContent='Desenha o padrão arrastando o dedo de ponto em ponto.';
  $('#pat-help').style.color='';
  $$('.dcard').forEach(b=>b.setAttribute('aria-checked','false'));
  $('#b-home').hidden=true; $('#b-store').hidden=true; $('#b-addr').hidden=true; $('#b-hours').hidden=true;
  $$('#dates .date, #storeday .chip, #hours .hour, #addrs .addr').forEach(b=>b.setAttribute('aria-pressed','false'));
  ['cp','street','door','city'].forEach(id=>$('#'+id).value='');
  $('#cp-side').innerHTML='';
  $$('#stores .store').forEach(b=>b.setAttribute('aria-checked','false'));
  $('#terms').checked=false;
  go(0); openFlow();
}
function goHome(then){ navTo(''); showView('home'); if(then) setTimeout(then,60); }
$$('[data-start]').forEach(a=>a.addEventListener('click',e=>{e.preventDefault(); startNewFlow();}));
$$('[data-home]').forEach(a=>a.addEventListener('click',e=>{e.preventDefault(); goHome();}));
/* Fechar o modal do flow (X) volta à vista anterior. */
$('#flow-close')&&$('#flow-close').addEventListener('click',()=>goHome());
$('#to-track').addEventListener('click',()=>openAccount('pick', lastRef));

function selectFrom(brand, series, model){
  openFlow(()=>{
    if(S.step!==0) go(0);
    if(brand){ const bt=$(`#brands .tile[data-b="${brand}"]`); if(bt && bt.getAttribute('aria-pressed')!=='true') bt.click(); }
    if(series){ const st=$(`#series .tile[data-s="${CSS.escape(series)}"]`); if(st && st.getAttribute('aria-pressed')!=='true') st.click(); }
    if(model){ pickModel(model); }
    setTimeout(()=>{
      const target = !brand ? $('#brands') : model ? $('#b-issue') : series ? $('#b-model') : $('#b-series');
      scrollToEl(target);
      if(!brand) $('#brands .tile').focus({preventScroll:true});
      else if(series && !model) $('#model').focus({preventScroll:true});
    }, 140);
  });
}
function findModel(name){
  for(const [brand,cats] of Object.entries(CATALOG)) for(const [cat,list] of Object.entries(cats)){ if(list.includes(name)) return [brand,cat,name]; }
  return null;
}
$$('.pop').forEach(b=>b.addEventListener('click',()=>{
  if(b.dataset.pending){ pendingSeries=b.dataset.pending; selectFrom('', '', ''); toast(b.dataset.pending==='Comando'?'Escolhe a marca do comando.':'Escolhe a marca do portátil.'); return; }
  selectFrom(b.dataset.brand, b.dataset.series, '');
}));

/* Models: what converts stays visible, the full index stays crawlable but folded */
const minBase=(names,sets)=>{ let m=Infinity; sets.forEach(set=>(REPAIRS[set]||[]).forEach(r=>{ if(names.includes(r[0])) m=Math.min(m,r[1]); })); return m===Infinity?null:m; };
const setsFor=(brand,series)=>series.map(se=>REPAIRS[`${brand}:${se}`]?`${brand}:${se}`:(REPAIRS[se]?se:(/Tab/.test(se)?'tablet':'phone')));
const fromPrice=(brand,series)=>{ let m=Infinity; setsFor(brand,series).forEach(k=>(REPAIRS[k]||[]).forEach(r=>{ m=Math.min(m,r[1]); })); return m; };
const GROUPS=[
  {t:'Telemóveis, tablets e relógios', ic:PHONE_SVG(), items:[['Apple',['iPhone','iPad','Apple Watch']],['Samsung',['Galaxy S','Galaxy A','Galaxy Z','Galaxy Tab']],['Xiaomi',['Redmi','Xiaomi','POCO']]]},
  {t:'Computadores', ic:LAP_SVG(), items:[['Apple',['MacBook','iMac']],['Lenovo',['Portátil']],['HP',['Portátil']],['Asus',['Portátil']]]},
  {t:'Consolas e comandos', ic:PAD_SVG(), items:[['PlayStation',['Consola','Comando']],['Xbox',['Consola','Comando']],['Nintendo',['Consola','Comando']]]}
];
function PHONE_SVG(){return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="6" y="2" width="12" height="20" rx="3"/><path d="M11 18h2"/></svg>'}
function LAP_SVG(){return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="4" y="5" width="16" height="11" rx="1.5"/><path d="M2 19h20"/></svg>'}
function PAD_SVG(){return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 9h10a4 4 0 014 4v1.5a2.5 2.5 0 01-4.6 1.3L15 14H9l-1.4 1.8A2.5 2.5 0 013 14.5V13a4 4 0 014-4z"/><path d="M8 11v2M7 12h2M15.5 12h.01M17.5 12h.01"/></svg>'}
$('#bgroups').innerHTML = GROUPS.map(g=>`<div class="bgroup"><h4><span class="bg-ic">${g.ic}</span>${g.t}</h4><ul class="bcards">${g.items.map(([brand,series])=>{
  const only = series.length===1 || (brand==='Apple' && g.t==='Computadores') ? '' : '';
  const pre = series.length===1 ? series[0] : '';
  return `<li><button type="button" class="bcard" data-b="${brand}" data-s="${pre}" data-cats="${series.join('|')}"><b>${brand}</b><small>${series.join(' · ')}</small><span class="bc-from">desde <strong>${eur(round5(fromPrice(brand,series)))}</strong></span><span class="bc-go" aria-hidden="true">→</span></button></li>`;}).join('')}</ul></div>`).join('');
$('#bgroups').addEventListener('click',e=>{
  const b=e.target.closest('.bcard'); if(!b) return;
  const cats=b.dataset.cats.split('|');
  // Apple appears twice (phones / computers): steer straight to that family's category step
  if(b.dataset.b==='Apple' && cats.includes('MacBook')) { selectFrom('Apple','',''); return; }
  selectFrom(b.dataset.b, b.dataset.s, '');
});

/* Full model index and every service, for search engines and LLMs only: structured
   data, not text hidden on the page. In Shopify this belongs in the Liquid template. */
(function seoCatalog(){
  const SERVICES=['Troca de ecrã','Troca de bateria','Porta de carregamento','Colunas','Microfone','Câmara','Botões (Home, Power, volume)','Chassis','Carregamento wireless','Face ID / Touch ID','Micro soldadura na placa-mãe','Diagnóstico técnico completo','Porta HDMI de consolas','Drift dos analógicos','Limpeza e pasta térmica','Leitor de discos','Teclado e dobradiças de portáteis','Recuperação de dados'];
  const offer=(name,min)=>({'@type':'Offer','itemOffered':{'@type':'Service','name':name},...(min?{'priceSpecification':{'@type':'PriceSpecification','minPrice':min,'priceCurrency':'EUR'}}:{})});
  const ld={'@context':'https://schema.org','@type':'Service','name':'Reparação de telemóveis, tablets, computadores, consolas e comandos','serviceType':'Assistência técnica e reparação de equipamentos eletrónicos',
    'provider':{'@type':'Organization','name':'iSell & Repair','url':'https://www.isell.pt','telephone':'+351 920 215 215'},
    'areaServed':{'@type':'Country','name':'Portugal'},
    'hasOfferCatalog':{'@type':'OfferCatalog','name':'Reparações','itemListElement':[
      {'@type':'OfferCatalog','name':'Tipos de reparação','itemListElement':SERVICES.map(n=>offer(n))},
      ...Object.entries(CATALOG).flatMap(([brand,cats])=>Object.entries(cats).map(([cat,list])=>{
        const set=REPAIRS[`${brand}:${cat}`]||REPAIRS[cat]||(/Tab/.test(cat)?REPAIRS.tablet:REPAIRS.phone);
        return {'@type':'OfferCatalog','name':`Reparação ${brand} ${cat}`,
          'itemListElement':list.map(m=>({'@type':'Offer','itemOffered':{'@type':'Product','name':m,'brand':{'@type':'Brand','name':brand}},
            'priceSpecification':{'@type':'PriceSpecification','minPrice':Math.min(...set.map(r=>r[1])),'priceCurrency':'EUR'}}))};
      }))]}};
  const el=document.createElement('script'); el.type='application/ld+json'; el.textContent=JSON.stringify(ld); document.head.appendChild(el);
})();

/* repair types with a real "from" price */
const TCARDS=[
  ['Troca de ecrã','Partido, com manchas ou toque a falhar',['Ecrã']],
  ['Troca de bateria','Autonomia curta ou desliga-se sozinho',['Bateria']],
  ['Porta de carregamento','Não carrega ou só com o cabo inclinado',['Porta de carregamento','Porta USB-C','Conector USB-C']],
  ['Câmara','Fotos desfocadas ou vidro da lente partido',['Câmara']],
  ['Porta HDMI','Consola sem imagem na televisão',['Porta HDMI']],
  ['Drift dos analógicos','O comando mexe-se sozinho',['Drift dos analógicos']],
  ['Contacto com líquidos','Caiu à água ou entornou-se algo',['Limpeza de líquidos']],
  ['Recuperação de dados','Não liga e precisas dos ficheiros',['Recuperação de dados']]];
const TICONS={"Troca de ecrã": "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"6\" y=\"2\" width=\"12\" height=\"20\" rx=\"2.5\"/><path d=\"M9.5 7l3 3-2 2.5 3 3\"/></svg>", "Troca de bateria": "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"2\" y=\"7\" width=\"17\" height=\"10\" rx=\"2\"/><path d=\"M22 11v2M6 10v4M9.5 10v4\"/></svg>", "Porta de carregamento": "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9 2v5M15 2v5M6 7h12v3a6 6 0 01-12 0z\"/><path d=\"M12 16v6\"/></svg>", "Câmara": "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3 8.5A2.5 2.5 0 015.5 6H7l1.5-2h7L17 6h1.5A2.5 2.5 0 0121 8.5v9a2.5 2.5 0 01-2.5 2.5h-13A2.5 2.5 0 013 17.5z\"/><circle cx=\"12\" cy=\"13\" r=\"3.5\"/></svg>", "Porta HDMI": "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"4\" width=\"18\" height=\"12\" rx=\"1.5\"/><path d=\"M8 20h8M12 16v4M8.5 8.5h7l-1 3h-5z\"/></svg>", "Drift dos analógicos": "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"12\" cy=\"7\" r=\"3\"/><path d=\"M12 10v5M4 18.5c0-1.9 3.6-3.5 8-3.5s8 1.6 8 3.5-3.6 2.5-8 2.5-8-.6-8-2.5zM18 5.5a6 6 0 011.5 3M6 5.5a6 6 0 00-1.5 3\"/></svg>", "Contacto com líquidos": "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12 3s6 6.4 6 11a6 6 0 01-12 0c0-4.6 6-11 6-11z\"/><path d=\"M9.5 14.5a2.5 2.5 0 002.5 2.5\"/></svg>", "Recuperação de dados": "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><ellipse cx=\"11\" cy=\"5\" rx=\"7\" ry=\"2.8\"/><path d=\"M4 5v6c0 1.5 3.1 2.8 7 2.8M18 5v5M4 11v6c0 1.5 3.1 2.8 7 2.8M18 14v7M15.5 18.5L18 21l2.5-2.5\"/></svg>"};
const ALLSETS=Object.keys(REPAIRS);
$('#tcards').innerHTML = TCARDS.map(([t,d,names])=>`<li><button type="button" class="tcard" data-r="${names.join('|')}"><span class="tc-ic">${TICONS[t]||WRENCH_SVG()}</span><span class="tc-t"><b>${t}</b><small>${d}</small></span><span class="tc-p">desde<strong>${eur(round5(minBase(names,ALLSETS)))}</strong></span></button></li>`).join('');
function WRENCH_SVG(){return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14.7 6.3a4 4 0 00-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 005.4-5.4l-2.5 2.5-2.5-.6-.6-2.5z"/></svg>'}
$('#tcards').addEventListener('click',e=>{ const b=e.target.closest('.tcard'); if(!b) return; pendingRepair=b.dataset.r.split('|'); selectFrom('','',''); toast('Escolhe o equipamento. Marcamos a reparação por ti.'); });

/* Header search: a model name takes you straight to its prices */
$('#site-search')?.addEventListener('submit',e=>{
  e.preventDefault(); const q=$('#site-q').value.trim().toLowerCase(); if(!q) return;
  for(const [brand,cats] of Object.entries(CATALOG)) for(const [cat,list] of Object.entries(cats)){
    const m=list.find(x=>x.toLowerCase()===q) || list.find(x=>x.toLowerCase().includes(q));
    if(m){ selectFrom(brand,cat,m); toast(`A mostrar preços para ${m}`); return; }
  }
  toast('Não encontrámos esse modelo. Escolhe a marca no configurador.'); openFlow();
});

/* ================= repairs & pickups: one model for the card and the account page ================= */
const REP_STATUS={
  booked:{l:'Agendado',tone:'amber',st:-1,open:true}, received:{l:'Recebido',tone:'amber',st:0,open:true},
  diag:{l:'Em diagnóstico',tone:'amber',st:1,open:true}, quote:{l:'Orçamento pendente',tone:'amber',st:1,open:true},
  repair:{l:'Em reparação',tone:'neutral',st:2,open:true}, qc:{l:'Em controlo de qualidade',tone:'amber',st:2,open:true},
  ready:{l:'Concluído',tone:'green',st:3,open:true}, delivered:{l:'Concluído',tone:'green',st:3,open:false},
  refused:{l:'Orçamento recusado',tone:'red',st:1,open:false}};
const PICK_STATUS={
  requested:{tone:'amber',open:true}, scheduled:{tone:'amber',open:true},
  transit:{tone:'amber',open:true}, atstore:{tone:'amber',open:true},
  returning:{tone:'amber',open:true}, returned:{tone:'amber',open:true},
  payment_pending:{tone:'amber',open:true}, cancelled:{tone:'red',open:false}};
const pickupStatus=pk=>({
  ...PICK_STATUS[pk.status],
  l:pk.status==='cancelled'?'Cancelado':'Agendado'
});
const STAGES=['Recebido','Diagnóstico','Reparação','Concluído'];
const CHK='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="4"><path d="M5 12l5 5 9-10"/></svg>';
const CHEV='<svg class="chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M9 6l6 6-6 6"/></svg>';
const CAL='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/></svg>';
const ARR='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
const EXT='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h5"/></svg>';
/* NACEX wordmark, drawn rather than loaded (the artifact can't fetch remote images). */
const NACEX='<span class="nacex" role="img" aria-label="NACEX"></span>';
const MON_LONG=['janeiro','fevereiro','março','abril','maio','junho','julho','agosto','setembro','outubro','novembro','dezembro'];
// Keep the calendar date supplied by the API, including SQL/ISO timestamps.
const dParse=x=>{ const m=String(x||'').match(/^(\d{4}-\d{2}-\d{2})(?:$|[ T])/); if(!m) return null; const d=new Date(m[1]+'T12:00'); return isNaN(d.getTime())?null:d; };
const dShort=x=>{const d=dParse(x);return d?`${PT_DAY[d.getDay()].slice(0,3)}, ${d.getDate()} ${PT_MON[d.getMonth()]}`:'—';};
const dLong=x=>{const d=dParse(x);return d?`${PT_DAY[d.getDay()]}, ${d.getDate()} de ${MON_LONG[d.getMonth()]}`:'—';};
const dNum=x=>{const d=dParse(x);return d?`${String(d.getDate()).padStart(2,'0')}/${String(d.getMonth()+1).padStart(2,'0')}/${d.getFullYear()}`:'—';};
const plus3y=x=>{const d=dParse(x); if(!d) return '—'; d.setFullYear(d.getFullYear()+3); return dNum(iso(d));};
const kindOf=se=>['Consola','Comando'].includes(se)?'console':(['MacBook','iMac','Portátil'].includes(se)?'laptop':'phone');
const kindIcon=k=>k==='console'?PAD_SVG():k==='laptop'?LAP_SVG():PHONE_SVG();
const STORE_ICON='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 10l2-6h14l2 6M3 10a3 3 0 006 0 3 3 0 006 0 3 3 0 006 0M5 13v7h14v-7M10 20v-6h4v6M9 10l1-6M15 10l-1-6"/></svg>';
const pill=o=>`<span class="stp t-${o.tone}"><span class="d"></span>${o.l}</span>`;
const pickWhen=pk=>pk.deliv==='store'
  ? esc((pk.store||'Loja por confirmar')+': '+(pk.date?dShort(pk.date)+(pk.time?' às '+pk.time:''):'Data por confirmar'))
  : (pk.date
    ? ({requested:'Data pedida: ',scheduled:'Recolha a ',transit:'Recolhida a ',atstore:'Recolhida a ',returning:'Devolução a ',returned:'Entregue a ',cancelled:'Data marcada: '}[pk.status]||'Recolha a ')+dShort(pk.date)
    : 'Data por confirmar');
const sortItems=(list,MAP,key)=>[...list].sort((a,b)=>(MAP[b.status].open-MAP[a.status].open)||String(b[key]).localeCompare(String(a[key])));
function nextRef(){ const all=(S.user&&S.user.jobs||[]).map(j=>+j.ref||0); return String(Math.max(22816,...all)+1); }
let lastRef='';
function timeline(j){
  const refused=j.status==='refused', stages=refused?['Recebido','Diagnóstico','Recusado']:STAGES;
  const st=refused?2:REP_STATUS[j.status].st, n=stages.length;
  const pct = st<0 ? 0 : (st/(n-1))*(100-100/n);
  return `<div class="track-line${refused?' is-red':''}" style="--n:${n}"><span class="fill" style="width:${pct}%"></span>${stages.map((nm,i)=>{
    const cls = i<st || (i===st && st===n-1) ? 'past' : i===st ? 'now' : '';
    return `<span class="tl-st ${cls}"><span class="tl-dot">${cls==='past'?CHK:''}</span>${nm}</span>`;}).join('')}</div>`;
}

/* backend /apps/reparacoes/mine → forma do protótipo (ícone, timeline, pill).
   Usado tanto pelo cartão da home (renderTrack) como pela área pessoal. */
function guessKind(model){
  var m = String(model||'');
  if(/playstation|\bps[45]\b|xbox|nintendo|switch|dualsense|dualshock|joy-?con|comando/i.test(m)) return 'console';
  if(/macbook|imac|port[áa]til|laptop|lenovo|\bhp\b|asus/i.test(m)) return 'laptop';
  return 'phone';
}
function repStatusKey(r){
  if(String(r.quotation_status)==='4' || /recusad/i.test(r.status_label||'')) return 'refused';
  switch(r.stage){ case 'received': return 'received'; case 'diagnosis': return 'diag'; case 'quote': return 'quote';
    case 'repair': return 'repair'; case 'ready': return 'ready'; case 'delivered': return 'delivered';
    default: return 'received'; }
}
function mapRepair(r){
  return { ref:String(r.repair_key||r.id||''), id:(+r.id||0), m:(r.model||'Equipamento'), kind:guessKind(r.model),
    status:repStatusKey(r), created:(r.created_date||''), updated:(r.modified_date||r.created_date||''), hasUpdate:!!r.modified_date, completed:(r.completed_date||''),
    items:[], deliv:(r.pickup?'home':'store'), store:(r.store_name||''), readonly:true,
    status_label:(r.status_label||''), reviewAvailable:!!r.review_available, reviewed:!!r.reviewed,
    photos:(Array.isArray(r.photos)?r.photos:[]).map(function(photo){return Number(photo&&typeof photo==='object'?photo.id:photo);}).filter(function(id){return Number.isInteger(id)&&id>0;}) };
}
function pickStatusKey(p){
  switch(p.state){ case 'requested': return 'requested'; case 'scheduled': return 'scheduled';
    case 'shipped': return 'transit'; case 'received': return 'returned';
    case 'payment_pending': return 'payment_pending'; case 'cancelled': return 'cancelled';
    default: return 'scheduled'; }
}
function mapPickup(p, repairs=[]){
  // "Sem reparação" pertence à reparação associada, não ao SOS. Nesse caso
  // o agendamento já não vai dar origem a qualquer intervenção.
  const linked=repairs.find(r=>p.repair_id && String(r.id)===String(p.repair_id));
  const noRepair=!!linked && (/sem reparação/i.test(linked.status_label||'') || String(linked.quotation_status)==='4');
  return { ref:String(p.id||p.repair_id||''), repRef:(p.repair_id?String(p.repair_id):''),
    m:(p.model||'Equipamento'), status:noRepair?'cancelled':pickStatusKey(p), date:(p.date||''), time:(p.time||''),
    deliv:(p.deliv==='store'||(!p.deliv&&!!p.store_name)?'store':'home'), store:(p.store_name||''), dir:'in',
    track:'', trackUrl:(p.tracking_url||''), addr:'' };
}

/* hero card: two rows per tab; the details live on the account page */
function repRowCard(j,noLink){
  return `<div class="job"><div class="job-top"><span class="job-ic">${kindIcon(j.kind)}</span><span class="job-tt"><b>${esc(j.m)}</b><span class="rf">#${esc(j.id || '—')}</span></span>${pill(REP_STATUS[j.status])}</div>${timeline(j)}<div class="job-foot"><span class="job-meta">${j.hasUpdate===false?'Recebido':'Atualizado'} a ${dNum(j.updated)}</span>${noLink?'':`<button type="button" class="job-link" data-open="rep" data-ref="${j.ref}">Acompanhar ${ARR}</button>`}</div></div>`;
}
function legacyLookupResult(data,ref){
  const repair=data.repair, job=mapRepair({...repair,repair_key:ref}), budget=repair.budget;
  const budgetLabel=budget?.state==='accepted'?'Aprovado':budget?.state==='declined'?'Recusado':budget?.state==='pending'?'Por decidir':'Disponível';
  const budgetTone=['accepted','declined','pending'].includes(budget?.state)?budget.state:'available';
  const budgetRows=budget&&Array.isArray(budget.lines)
    ? budget.lines.map(line=>`<div><dt>${esc(line.description||'Intervenção')}</dt><dd>${eur(+line.final_price||0)}</dd></div>`).join('') : '';
  const budgetActions=budget?.state==='pending'&&data.access_token
    ? `<div class="legacy-budget-actions" data-lookup-budget><button type="button" class="btn green" data-lookup-action="accept">Aprovar orçamento</button><button type="button" class="btn-ghost" data-lookup-action="decline">Recusar</button></div>` : '';
  const budgetHtml=budgetRows
    ? `<section class="legacy-budget" aria-label="Orçamento"><div class="legacy-section-heading"><h4>Orçamento</h4><span class="legacy-budget-state is-${budgetTone}">${budgetLabel}</span></div><dl class="legacy-budget-lines">${budgetRows}<div class="legacy-budget-total"><dt>Total</dt><dd>${eur(+budget.total||0)}</dd></div></dl>${budgetActions}</section>` : '';
  const reviewHtml=!portalState.authenticated&&repair.review_available&&!repair.reviewed
    ? `<div class="legacy-result-actions"><button type="button" class="btn green" data-guest-review="${esc(ref)}">Avaliar reparação ${ARR}</button></div>` : '';
  return `<section class="legacy-result" aria-label="Estado da reparação" tabindex="-1"><div class="legacy-result-head"><span class="legacy-result-icon">${kindIcon(job.kind)}</span><div class="legacy-result-name"><span>Reparação #${esc(job.id||'—')}</span><h3>${esc(job.m)}</h3></div>${pill(REP_STATUS[job.status])}</div><div class="legacy-progress">${timeline(job)}</div><p class="legacy-updated">${job.hasUpdate===false?'Recebido':'Atualizado'} a ${dNum(job.updated)}</p>${budgetHtml}${reviewHtml}</section>`;
}
function pickCard(pk){
  const store=pk.deliv==='store';
  return `<div class="job pick"><div class="job-top">${store?('<span class="job-ic">'+STORE_ICON+'</span>'):NACEX}<span class="job-tt"><b>${esc(pk.m)}</b><span class="rf">#${esc(pk.ref)}</span></span>${pill(pickupStatus(pk))}</div><div class="job-foot"><span class="job-meta">${CAL}${pickWhen(pk)}</span><button type="button" class="job-link" data-open="pick" data-ref="${pk.ref}">${store?'Ver detalhes':'Seguir envio'} ${ARR}</button></div></div>`;
}
let trkTab='rep';
const portalState = {loading:!!(window.ISELL && window.ISELL.customer), authenticated:false, repairs:[], pickups:[], error:false};
let legacyLookupNeeded=false;
let repairLinkModal=null;
function closeRepairLinkModal(){
  if(!repairLinkModal) return;
  const modal=repairLinkModal, anon=$('#trk-anon');
  $('#trk-form').hidden=false;
  $('#trk-ref').closest('.f').hidden=false;
  $('#trk-status').after(anon);
  modal.remove();
  repairLinkModal=null;
  legacyLookupNeeded=false;
  renderTrack();
}
function openRepairLinkModal(ref){
  if(repairLinkModal) return;
  legacyLookupNeeded=true;
  $('#trk-ref').value=ref;
  $('#trk-form').hidden=false;
  $('#trk-ref').closest('.f').hidden=true;
  $('#trk-err').hidden=true;
  $('#trk-result').hidden=true;
  $('#trk-result').innerHTML='';
  renderTrack();
  const modal=document.createElement('div');
  modal.id='repair-link-modal';
  modal.className='review-modal';
  modal.innerHTML=`<div class="review-dialog legacy-repair-dialog" role="dialog" aria-modal="true" aria-labelledby="repair-link-title"><button class="review-close" type="button" data-close aria-label="Fechar">×</button><div class="review-heading"><div><span class="legacy-kicker">Acompanhamento</span><h2 id="repair-link-title">A tua reparação</h2><p>Referência <strong>#${esc(ref)}</strong> · Confirma o telemóvel associado.</p></div></div><div data-lookup-slot></div></div>`;
  modal.querySelector('[data-lookup-slot]').appendChild($('#trk-anon'));
  modal.addEventListener('click',e=>{if(e.target===modal||e.target.closest('[data-close]')) closeRepairLinkModal();});
  modal.addEventListener('keydown',e=>{if(e.key==='Escape') closeRepairLinkModal();});
  (document.querySelector('.repair-portal')||document.body).appendChild(modal);
  repairLinkModal=modal;
  $('#trk-phone').focus({preventScroll:true});
}
const portalUrl = tab => '/pages/historico'+(tab==='pick'?'?tab=recolhas':'');
function portalRow(item, type){
  const repair = type==='rep';
  const ref = item.id;
  const model = item.model || 'Equipamento';
  const status = repair ? item.status_label : pickupStatus(mapPickup(item, portalState.repairs)).l;
  return `<div class="job"><div class="job-top"><span class="job-tt"><b>${esc(model)}</b><span class="rf">${repair?'Reparação':'Pedido'} #${esc(ref)}</span></span></div><div class="job-foot"><span class="job-meta">${esc(status||'Em acompanhamento')}</span><a class="job-link" href="${portalUrl(type)}">Ver detalhes ${ARR}</a></div></div>`;
}
/* Loading mascarado (skeleton shimmer) — placeholders enquanto o App Proxy
   responde, em vez de spinner/texto. */
function skRow(){ return '<div class="sk-card" aria-hidden="true"><span class="sk-ic sk-bar"></span><span class="sk-main"><span class="sk-bar" style="width:62%;height:13px"></span><span class="sk-bar" style="width:40%;height:11px"></span></span><span class="sk-pill sk-bar"></span></div>'; }
function skList(n){ var o=''; for(var i=0;i<(n||3);i++) o+=skRow(); return '<div class="sk-list">'+o+'</div>'; }
function skDetail(){ return '<div class="sk-detail" aria-hidden="true"><span class="sk-bar" style="width:48%;height:20px"></span><span class="sk-bar" style="width:100%;height:60px"></span><span class="sk-bar" style="width:100%;height:40px"></span><span class="sk-bar" style="width:70%;height:40px"></span></div>'; }
function skBudget(){ return '<dl class="md-items" aria-hidden="true"><div><dt><span class="sk-bar" style="width:140px;height:12px"></span></dt><dd><span class="sk-bar" style="width:56px;height:12px"></span></dd></div><div><dt><span class="sk-bar" style="width:110px;height:12px"></span></dt><dd><span class="sk-bar" style="width:56px;height:12px"></span></dd></div><div class="md-total"><dt><span class="sk-bar" style="width:120px;height:14px"></span></dt><dd><span class="sk-bar" style="width:70px;height:16px"></span></dd></div></dl>'; }
function renderTrack(){
  const status = $('#trk-status');
  if(portalState.loading){
    status.hidden = true;
    $('#trk-anon').hidden = true; $('#trk-user').hidden = false;
    const th=$('#track-h'); if(th) th.textContent='As minhas reparações';
    $('#trk-list').innerHTML = skList(2);
    return;
  }
  status.hidden = !portalState.loading && !portalState.error;
  status.textContent = portalState.error ? 'Não foi possível carregar os processos. Abre a área pessoal para tentar novamente.' : 'A verificar a tua conta…';
  $('#trk-anon').hidden = portalState.loading || (portalState.authenticated && !legacyLookupNeeded);
  $('#trk-user').hidden = !portalState.authenticated || legacyLookupNeeded;
  $('#trk-phone').closest('.f').hidden = portalState.authenticated && !legacyLookupNeeded;
  $('.trk-login').hidden = portalState.authenticated;
  $('#trk-back').hidden = !portalState.authenticated || !legacyLookupNeeded;
  $('#trk-go').firstChild.textContent = portalState.authenticated ? 'Associar ' : 'Acompanhar ';
  $('#trk-associate').hidden = !portalState.authenticated || legacyLookupNeeded;
  $('#track-h').textContent = portalState.authenticated
    ? (legacyLookupNeeded ? 'Associar uma reparação' : 'As minhas reparações')
    : 'Acompanha a tua reparação';
  $('#site-acc')?.classList.toggle('signed',portalState.authenticated);
  if(!portalState.authenticated) return;
  const jobs=portalState.repairs, picks=portalState.pickups;
  $('#trk-all').hidden = jobs.length === 0 && picks.length === 0;
  $('#cnt-rep').textContent=jobs.length; $('#cnt-pick').textContent=picks.length;
  $$('.trk-tabs button').forEach(b=>{const on=b.dataset.t===trkTab;b.classList.toggle('is-on',on);b.setAttribute('aria-selected',on)});
  $('#trk-list').innerHTML = trkTab==='rep'
    ? (jobs.length?jobs.slice(0,2).map(j=>repRowCard(mapRepair(j))).join(''):'<p class="trk-empty">Ainda não tens reparações associadas.</p>')
    : (picks.length?picks.slice(0,2).map(p=>pickCard(mapPickup(p, portalState.repairs))).join(''):'<p class="trk-empty">Ainda não tens recolhas.</p>');
}

/* ================= account page ================= */
let mrTab='rep', mrSel=null, mrQ='', mrConfirm=false;
const isNarrow=()=>matchMedia('(max-width:900px)').matches;
function openAccount(tab, ref){
  window.location.assign(portalUrl(tab));
}
function mrRepRow(j){ const s=REP_STATUS[j.status], on=j.ref===mrSel;
  return `<button type="button" class="mr-row${on?' is-sel':''}" data-ref="${j.ref}" aria-pressed="${on}"><span class="mr-ic">${kindIcon(j.kind)}</span><span class="mr-main"><b>${esc(j.m)}</b><span class="rf">#${esc(j.id || '—')}</span></span><span class="mr-st"><span class="stl t-${s.tone}"><span class="d"></span>${s.l}</span><small>${j.hasUpdate===false?'Recebido':'Atualizado'} a ${dNum(j.updated)}</small></span>${CHEV}</button>`; }
function mrPickRow(pk){ const s=pickupStatus(pk), on=pk.ref===mrSel, store=pk.deliv==='store';
  return `<button type="button" class="mr-row${on?' is-sel':''}" data-ref="${pk.ref}" aria-pressed="${on}"><span class="mr-ic${store?'':' nx'}">${store?STORE_ICON:NACEX}</span><span class="mr-main"><b>${esc(pk.m)}</b><span class="rf">#${esc(pk.ref)}</span></span><span class="mr-st"><span class="stl t-${s.tone}"><span class="d"></span>${s.l}</span><small>${pickWhen(pk)}</small></span>${CHEV}</button>`; }
function repDetail(j){
  const s=REP_STATUS[j.status], total=j.items.reduce((a,i)=>a+i[1],0), pk=(S.user.picks||[]).find(x=>x.ref===j.ref);
  const where = j.deliv==='home' ? 'Recolha e devolução NACEX' : j.store;
  const msg = {
    booked: j.deliv==='home'?`Pedido agendado. A NACEX recolhe o equipamento ${pk?'na '+dLong(pk.date).toLowerCase():'na data marcada'}.`:`Pedido agendado. Esperamos-te na ${j.store}.`,
    received:'Recebemos o equipamento. O diagnóstico começa no próximo dia útil.',
    diag:'Estamos a diagnosticar o equipamento.',
    quote:'Orçamento pendente. Aprova para iniciarmos a reparação.',
    repair:'O técnico está a reparar o equipamento.',
    qc:'Reparação concluída. Estamos a testar tudo antes da entrega.',
    ready: j.deliv==='home'?'Está pronto. A devolução pela NACEX é agendada no próximo dia útil.':'Está disponível para levantamento.',
    delivered:dParse(j.completed)?`Entregue a ${dNum(j.completed)}.`:'Equipamento entregue.',
    refused:'Recusaste o orçamento.'}[j.status];
  let actions='';
  if(!j.readonly){
    if(j.status==='quote') actions = mrConfirm
      ? `<div class="md-confirm"><span>Recusar o orçamento? Devolvemos o equipamento sem custos.</span><div><button type="button" class="btn-ghost danger" data-act="refuse-yes">Sim, recusar</button><button type="button" class="btn-ghost" data-act="refuse-no">Cancelar</button></div></div>`
      : `<button type="button" class="btn green" data-act="approve">Aprovar orçamento · ${eur(total)}</button><button type="button" class="btn-ghost" data-act="refuse">Recusar</button>`;
    if(['delivered','refused'].includes(j.status)) actions += `<button type="button" class="btn-ghost" data-act="new">Pedir nova reparação</button>`;
  }
  const whereRow = j.deliv==='store' && j.store ? `<div><dt>Loja</dt><dd>${esc(j.store)}</dd></div>` : '';
  const reviewAction = j.reviewAvailable && !j.reviewed
    ? `<div class="md-actions md-review-actions"><button type="button" class="btn green" data-act="review">Avaliar reparação</button></div>`
    : j.reviewed ? '<p class="md-msg t-green">Obrigado pela tua avaliação.</p>' : '';
  const itemsBlock = j.items && j.items.length
    ? `<dl class="md-items">${j.items.map(i=>`<div><dt>${esc(i[0])}</dt><dd>${i[1]?eur(i[1]):'A orçamentar'}</dd></div>`).join('')}<div class="md-total"><dt>${j.status==='quote'?'Total do orçamento':'Total'}</dt><dd>${eur(total)}</dd></div></dl>`
    : '';
  return `<div class="md">
    <button type="button" class="md-back" data-back>${CHEV}Todas as reparações</button>
    <div class="md-top"><span class="mr-ic lg">${kindIcon(j.kind)}</span><div class="md-tt"><h2>${esc(j.m)}</h2><span class="rf">#${esc(j.id || '—')}</span></div>${pill(s)}</div>
    ${timeline(j)}
    <p class="md-msg t-${s.tone}">${msg}</p>
    ${itemsBlock}
    ${j.readonly?`<div class="md-budget" id="md-budget" hidden></div>`:''}
    <dl class="md-meta">${whereRow}<div><dt>Recebido</dt><dd>${dNum(j.created)}</dd></div><div><dt>Última atualização</dt><dd>${j.hasUpdate===false?'Sem atualizações posteriores':dNum(j.updated)}</dd></div></dl>
    ${(j.id&&j.photos&&j.photos.length)?`<div class="md-photos"><span class="md-photos-h">Fotos da reparação</span><div class="md-photos-grid">${j.photos.map(function(pid){var u='/apps/reparacoes/photo/'+j.id+'/'+encodeURIComponent(pid);return '<a class="md-photo" href="'+u+'" data-photo-src="'+u+'" target="_blank" rel="noopener"><img loading="lazy" src="'+u+'" alt="Foto da reparação"></a>';}).join('')}</div></div>`:''}
    ${actions?`<div class="md-actions">${actions}</div>`:''}
    ${reviewAction}
  </div>`;
}
function openReviewModal(j){
  if(!j || !j.reviewAvailable || j.reviewed) return;
  const old=document.getElementById('repair-review-modal'); if(old) old.remove();
  const modal=document.createElement('div'); modal.id='repair-review-modal'; modal.className='review-modal';
  const ratingRow=(name,label)=>`<div class="review-rating"><span id="review-${name}">${label}</span><div class="review-stars" role="group" aria-labelledby="review-${name}"><input type="hidden" name="${name}" value="0">${[1,2,3,4,5].map(n=>`<button type="button" data-star="${n}" aria-label="${n} ${n===1?'estrela':'estrelas'}" aria-pressed="false">★</button>`).join('')}</div></div>`;
  modal.innerHTML=`<div class="review-dialog" role="dialog" aria-modal="true" aria-labelledby="review-title"><button class="review-close" type="button" data-close aria-label="Fechar">×</button><div class="review-heading"><div><h2 id="review-title">Como correu a reparação?</h2><p>#${esc(j.id || '—')} - ${esc(j.m)}</p></div></div><form>${ratingRow('service_rating','Atendimento')}${ratingRow('time_rating','Tempo de reparação')}${ratingRow('quality_rating','Qualidade da reparação')}<p class="review-error" role="alert" hidden></p><button class="btn green" type="submit">Enviar avaliação</button></form></div>`;
  modal.addEventListener('click',e=>{if(e.target===modal||e.target.closest('[data-close]')) modal.remove();});
  modal.addEventListener('click',e=>{const star=e.target.closest('[data-star]');if(!star)return;const group=star.closest('.review-stars'),value=+star.dataset.star;group.querySelector('input').value=value;group.querySelectorAll('[data-star]').forEach(b=>{const selected=+b.dataset.star===value;b.classList.toggle('is-filled',+b.dataset.star<=value);b.setAttribute('aria-pressed',selected?'true':'false');});modal.querySelector('.review-error').hidden=true;});
  modal.addEventListener('keydown',e=>{if(e.key==='Escape') modal.remove();});
  modal.querySelector('form').addEventListener('submit',e=>{e.preventDefault();const cfg=window.ISELL||{}, f=new FormData(e.currentTarget), err=modal.querySelector('.review-error'), b=e.currentTarget.querySelector('button[type=submit]'), service=+f.get('service_rating'),time=+f.get('time_rating'),quality=+f.get('quality_rating');if(!service||!time||!quality){err.hidden=false;err.textContent='Escolhe uma classificação para os três critérios.';return;}if(!cfg.reviewUrl)return;b.disabled=true;fetch(cfg.reviewUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify({repair_id:j.id,service_rating:service,time_rating:time,quality_rating:quality})}).then(r=>r.ok?r.json():Promise.reject()).then(()=>{j.reviewed=true;modal.remove();renderAccount();toast('Obrigado pela tua avaliação.');}).catch(()=>{err.hidden=false;err.textContent='Não foi possível enviar a avaliação. Tenta novamente.';b.disabled=false;});});
  (document.querySelector('.repair-portal')||document.body).appendChild(modal); modal.querySelector('.review-stars button').focus();
}
/* Lightbox para as fotos da reparação: preview num modal em vez de abrir aba. */
function openPhotoLightbox(src){
  const old=document.getElementById('photo-lightbox'); if(old) old.remove();
  const m=document.createElement('div'); m.id='photo-lightbox'; m.className='photo-lightbox'; m.tabIndex=-1;
  m.innerHTML='<div class="plb-dialog" role="dialog" aria-modal="true" aria-label="Foto da reparação"><button class="plb-close" type="button" data-close aria-label="Fechar">&times;</button><img class="plb-img" src="'+src+'" alt="Foto da reparação"></div>';
  m.addEventListener('click',function(e){ if(e.target===m||e.target.closest('[data-close]')) m.remove(); });
  m.addEventListener('keydown',function(e){ if(e.key==='Escape') m.remove(); });
  (document.querySelector('.repair-portal')||document.body).appendChild(m); m.querySelector('[data-close]').focus();
}
document.addEventListener('click',function(e){
  const a=e.target.closest('.md-photo'); if(!a) return;
  if(e.metaKey||e.ctrlKey||e.shiftKey||e.button>0) return;
  e.preventDefault(); openPhotoLightbox(a.getAttribute('data-photo-src')||a.getAttribute('href'));
});
function openGuestReviewModal(ref){
  const cfg=window.ISELL||{};
  if(!cfg.guestReviewByRefUrl) return;
  const old=document.getElementById('repair-review-modal'); if(old) old.remove();
  const modal=document.createElement('div'); modal.id='repair-review-modal'; modal.className='review-modal';
  const ratingRow=(name,label)=>`<div class="review-rating"><span id="guest-review-${name}">${label}</span><div class="review-stars" role="group" aria-labelledby="guest-review-${name}"><input type="hidden" name="${name}" value="0">${[1,2,3,4,5].map(n=>`<button type="button" data-star="${n}" aria-label="${n} ${n===1?'estrela':'estrelas'}" aria-pressed="false">★</button>`).join('')}</div></div>`;
  modal.innerHTML=`<div class="review-dialog" role="dialog" aria-modal="true" aria-labelledby="review-title"><button class="review-close" type="button" data-close aria-label="Fechar">×</button><div class="review-heading"><div><h2 id="review-title">Avaliar a reparação</h2><p>Referência #${esc(ref)}</p></div></div><form>${ratingRow('service_rating','Atendimento')}${ratingRow('time_rating','Tempo de reparação')}${ratingRow('quality_rating','Qualidade da reparação')}<p class="review-error" role="alert" hidden></p><button class="btn green" type="submit">Enviar avaliação</button></form></div>`;
  const error=modal.querySelector('.review-error');
  modal.addEventListener('click',e=>{
    if(e.target===modal||e.target.closest('[data-close]')){modal.remove();return;}
    const star=e.target.closest('[data-star]'); if(!star)return;
    const group=star.closest('.review-stars'),value=+star.dataset.star;
    group.querySelector('input').value=value;
    group.querySelectorAll('[data-star]').forEach(b=>{b.classList.toggle('is-filled',+b.dataset.star<=value);b.setAttribute('aria-pressed',b===star?'true':'false');});
    error.hidden=true;
  });
  modal.addEventListener('keydown',e=>{if(e.key==='Escape')modal.remove();});
  modal.querySelector('form').addEventListener('submit',async e=>{
    e.preventDefault();
    const form=e.currentTarget,data=new FormData(form),button=form.querySelector('[type=submit]');
    const ratings={service_rating:+data.get('service_rating'),time_rating:+data.get('time_rating'),quality_rating:+data.get('quality_rating')};
    error.hidden=true;
    if(Object.values(ratings).some(v=>!v)){error.textContent='Escolhe uma classificação para os três critérios.';error.hidden=false;return;}
    button.disabled=true;
    try{
      const response=await fetch(cfg.guestReviewByRefUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify({repair_key:ref,...ratings})});
      const result=await response.json().catch(()=>({}));
      if(!response.ok) throw new Error(result.error||'request_failed');
      document.querySelectorAll('[data-guest-review]').forEach(b=>{
        if(b.dataset.guestReview===ref){const action=b.closest('.legacy-result-actions, .md-review-actions');if(action)action.innerHTML='<p class="md-msg t-green">Obrigado pela tua avaliação.</p>';}
      });
      modal.remove();toast('Obrigado pela tua avaliação.');
    }catch(err){
      error.textContent=err.message==='already_reviewed'?'Esta reparação já foi avaliada.':err.message==='too_many_attempts'?'Há demasiadas tentativas. Aguarda alguns minutos.':err.message==='not_found'?'Esta reparação ainda não está disponível para avaliação.':'Não foi possível enviar a avaliação. Tenta novamente.';
      error.hidden=false;
    }finally{button.disabled=false;}
  });
  (document.querySelector('.repair-portal')||document.body).appendChild(modal); modal.querySelector('.review-stars button').focus();
}
function pickDetail(pk){
  const s=pickupStatus(pk), store=pk.deliv==='store', dir=store?esc(pk.store||'Loja por confirmar'):(pk.dir==='in'?'Recolha':'Devolução');
  const lbl = store?esc(pk.store||'Loja por confirmar'):(pk.status==='cancelled'?'Data marcada':pk.status==='requested'?'Data pedida':pk.status==='scheduled'?'Data de recolha':pk.status==='returning'?'Entrega prevista':pk.dir==='in'?'Recolhida a':'Entregue a');
  const whenBig = pk.date?(dLong(pk.date)+(store&&pk.time?' às '+pk.time:'')):'Por confirmar';
  const headIc = store?STORE_ICON:NACEX;
  return `<div class="md">
    <button type="button" class="md-back" data-back>${CHEV}Todas as recolhas</button>
    <div class="md-top"><span class="mr-ic lg${store?'':' nx'}">${headIc}</span><div class="md-tt"><h2>${dir} · ${esc(pk.m)}</h2><span class="rf">#${esc(pk.ref)}</span></div>${pill(s)}</div>
    <div class="pk-date-lg"><span class="pk-cal">${CAL}</span><span><small>${lbl}</small><b>${whenBig}</b></span></div>
    ${store?`<dl class="md-meta"><div><dt>Loja escolhida</dt><dd>${esc(pk.store||'Por confirmar')}</dd></div></dl>`:''}
    ${pk.status==='scheduled'?`<p class="md-msg t-amber">${store?'Se possível, leva o equipamento desligado e com cópia de segurança.':'Se possível, deixa o equipamento desligado e com cópia de segurança.'}</p>`:''}
    ${(pk.addr||pk.track)?`<dl class="md-meta">${pk.addr?`<div><dt>Morada</dt><dd>${esc(pk.addr)}</dd></div>`:''}${pk.track?`<div><dt>N.º de envio</dt><dd class="trk-no"><span>${esc(pk.track)}</span><button type="button" class="copy" data-act="copy" data-v="${esc(pk.track)}">Copiar</button></dd></div>`:''}</dl>`:''}
    ${pk.trackUrl?`<div class="md-actions"><a class="btn green" href="${esc(pk.trackUrl)}" target="_blank" rel="noopener">Seguir envio ${EXT}</a></div>`:''}
  </div>`;
}
/* Orçamento na conta: para uma reparação real em "quote", vai buscar as linhas
   do orçamento + access_token via /apps/reparacoes/lookup e permite aprovar/
   recusar via /apps/reparacoes/budget-decision. */
function loadBudget(ref){
  var box = document.getElementById('md-budget'); if(!box) return;
  var cfg = window.ISELL || {};
  if(!cfg.lookupUrl || !ref){ box.hidden = true; return; }
  box.hidden = false; box.innerHTML = skBudget();
  fetch(cfg.lookupUrl, {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, credentials:'same-origin', body:JSON.stringify({repair_key:ref})})
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(d){
      if(!d || !d.repair || !d.repair.budget){ box.hidden = true; return; }
      var b = d.repair.budget, tok = d.access_token || '';
      var lines = (b.lines||[]).map(function(l){ return '<div><dt>'+esc(l.description||'')+'</dt><dd>'+eur(+l.final_price||0)+'</dd></div>'; }).join('');
      var pending = b.state === 'pending';
      var html = '<dl class="md-items">'+lines+'<div class="md-total"><dt>Total do orçamento</dt><dd>'+eur(+b.total||0)+'</dd></div></dl>';
      if(pending){
        html += '<div class="md-actions" data-budget-token="'+esc(tok)+'"><button type="button" class="btn green" data-bud="accept">Aprovar orçamento · '+eur(+b.total||0)+'</button><button type="button" class="btn-ghost" data-bud="decline">Recusar</button></div>';
      } else if(b.state === 'accepted'){
        html += '<p class="md-msg t-green">Orçamento aprovado — a reparação avança.</p>';
      } else if(b.state === 'declined'){
        html += '<p class="md-msg t-red">Orçamento recusado. Devolvemos o equipamento sem custos.</p>';
      }
      box.innerHTML = html; box.hidden = false;
    })
    .catch(function(){ box.hidden = true; });
}
document.addEventListener('click', function(e){
  var btn = e.target.closest('[data-bud]'); if(!btn) return;
  var wrap = btn.closest('[data-budget-token]'); var tok = wrap ? wrap.getAttribute('data-budget-token') : '';
  var action = btn.getAttribute('data-bud'); var cfg = window.ISELL || {};
  if(!cfg.budgetUrl || !tok || wrap.dataset.submitting === 'true') return;
  var decisionRef = mrSel;
  if(action === 'decline' && !confirm('Recusar o orçamento? Devolvemos o equipamento sem custos.')) return;
  wrap.dataset.submitting = 'true';
  wrap.querySelectorAll('button').forEach(function(b){ b.disabled=true; b.setAttribute('aria-disabled','true'); });
  fetch(cfg.budgetUrl, {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, credentials:'same-origin', body:JSON.stringify({access_token:tok, action:action})})
    .then(function(r){ return r.json().catch(function(){return {};}).then(function(j){ return {ok:r.ok, j:j}; }); })
    .then(function(res){
      if(!res.ok){ throw new Error((res.j && res.j.error) || 'decision_failed'); }
      try{ toast(action==='accept' ? 'Orçamento aprovado. Começamos a reparação.' : 'Orçamento recusado. Devolvemos o equipamento sem custos.'); }catch(_){}
      // The decision is saved. Update this repair without navigating or resetting the filters.
      var job = S.user && (S.user.jobs||[]).find(function(j){ return j.ref === decisionRef; });
      if(job) job.status = action === 'accept' ? 'repair' : 'refused';
      var repair = portalState.repairs.find(function(r){ return String(r.repair_key||r.id) === decisionRef; });
      if(repair){ repair.quotation_status = action === 'accept' ? '3' : '4'; repair.stage = action === 'accept' ? 'repair' : 'quote'; }
      renderAccount(); renderTrack();
      if(cfg.mineUrl) {
        fetch(cfg.mineUrl, {method:'POST', headers:{Accept:'application/json'}, credentials:'same-origin'})
          .then(function(r){ if(!r.ok) throw new Error('refresh_failed'); return r.json(); })
          .then(function(data){
            if(!data || !Array.isArray(data.repairs) || !Array.isArray(data.pickups)) throw new Error('refresh_failed');
            portalState.repairs=data.repairs; portalState.pickups=data.pickups;
            if(S.user){ S.user.jobs=data.repairs.map(mapRepair); S.user.picks=data.pickups.map(p=>mapPickup(p, data.repairs)); }
            renderAccount(); renderTrack();
          })
          .catch(function(){ toast('A decisão ficou registada. Não foi possível atualizar os restantes dados agora.'); });
      }
    })
    .catch(function(){
      delete wrap.dataset.submitting;
      wrap.querySelectorAll('button').forEach(function(b){ b.disabled=false; b.removeAttribute('aria-disabled'); });
      try{ toast('Não foi possível registar a decisão. Atualiza a página e tenta novamente.'); }catch(_){}
    });
});
function renderAccount(){
  const u=S.user;
  if(!u && portalState.loading){
    $('#mr-gate').hidden=true; $('#mr-app').hidden=false;
    $('#mr-list').innerHTML = skList(3);
    $('#mr-detail').innerHTML = skDetail();
    const g=$('.mr-grid'); if(g) g.classList.remove('has-sel');
    return;
  }
  $('#mr-gate').hidden=!!u; $('#mr-app').hidden=!u;
  if(!u) return;
  const jobs=sortItems(u.jobs||[],REP_STATUS,'updated'), picks=sortItems(u.picks||[],PICK_STATUS,'date');
  $('#mr-cnt-rep').textContent=jobs.length; $('#mr-cnt-pick').textContent=picks.length;
  $$('.mr-tabs button').forEach(b=>{const on=b.dataset.t===mrTab;b.classList.toggle('is-on',on);b.setAttribute('aria-selected',on)});
  const MAP=mrTab==='rep'?REP_STATUS:PICK_STATUS, all=mrTab==='rep'?jobs:picks, q=mrQ.trim().toLowerCase();
  const items = q ? all.filter(x=>(x.m+' '+x.ref+' '+(mrTab==='rep'?MAP[x.status].l:pickupStatus(x).l)).toLowerCase().includes(q)) : all;
  if(!isNarrow() && !items.find(x=>x.ref===mrSel)) mrSel = items[0] ? items[0].ref : null;
  const row=mrTab==='rep'?mrRepRow:mrPickRow;
  const grp=(t,list)=>list.length?`<h3 class="mr-grp">${t}<span>${list.length}</span></h3>${list.map(row).join('')}`:'';
  $('#mr-list').innerHTML = items.length
    ? grp(mrTab==='rep'?'Em curso':'Agendados', items.filter(x=>MAP[x.status].open)) + grp(mrTab==='rep'?'Concluídas':'Cancelados', items.filter(x=>!MAP[x.status].open))
    : `<p class="mr-empty">${q?'Não encontrámos nada com essa pesquisa.':(mrTab==='rep'?'Ainda não tens reparações.':'Ainda não tens recolhas.')}</p>`;
  const sel=all.find(x=>x.ref===mrSel);
  $('#mr-detail').innerHTML = sel ? (mrTab==='rep'?repDetail(sel):pickDetail(sel)) : `<p class="md-empty">Escolhe ${mrTab==='rep'?'uma reparação':'uma recolha'} para veres os detalhes.</p>`;
  if(sel && mrTab==='rep' && sel.readonly && sel.status==='quote') loadBudget(sel.ref);
  $('.mr-grid').classList.toggle('has-sel', !!sel);
}
$$('.mr-tabs button').forEach(b=>b.addEventListener('click',()=>{ mrTab=b.dataset.t; mrSel=null; mrConfirm=false; renderAccount(); }));
$('#mr-q').addEventListener('input',e=>{ mrQ=e.target.value; renderAccount(); });
$('#mr-list').addEventListener('click',e=>{ const r=e.target.closest('.mr-row'); if(!r) return; mrSel=r.dataset.ref; mrConfirm=false; renderAccount(); if(isNarrow()) alignTop($('#mr-detail')); });
$('#mr-detail').addEventListener('click',e=>{
  if(e.target.closest('[data-back]')){ mrSel=null; renderAccount(); alignTop($('.mr-bar')); return; }
  const a=e.target.closest('[data-act]'); if(!a) return;
  const j=(S.user.jobs||[]).find(x=>x.ref===mrSel), today=iso(new Date());
  switch(a.dataset.act){
    case 'approve': j.status='repair'; j.updated=today; toast('Orçamento aprovado. Começamos a reparação.'); break;
    case 'refuse': mrConfirm=true; break;
    case 'refuse-yes': j.status='refused'; j.updated=today; mrConfirm=false; toast('Orçamento recusado. Devolvemos o equipamento sem custos.'); break;
    case 'refuse-no': mrConfirm=false; break;
    case 'pick': mrTab='pick'; mrSel=a.dataset.ref; break;
    case 'rep': mrTab='rep'; mrSel=a.dataset.ref; break;
    case 'new': startNewFlow(); return;
    case 'review': openReviewModal(j); return;
    case 'copy': {
      const v=a.dataset.v;
      const done=()=>{ a.textContent='Copiado'; setTimeout(()=>{a.textContent='Copiar'},1600); };
      try{ navigator.clipboard.writeText(v).then(done,()=>{ selectText(a.previousElementSibling); toast('Seleciona e copia o número.'); }); }catch(_){ selectText(a.previousElementSibling); }
      return; }
  }
  renderAccount(); renderTrack();
});
function selectText(el){ const r=document.createRange(); r.selectNodeContents(el); const sel=getSelection(); sel.removeAllRanges(); sel.addRange(r); }

function afterAuth(){ renderTrack(); if(view==='account') renderAccount(); }
function afterBooking(){
  if(!S.user) return;
  const today=iso(new Date());
  const items=priced().L.map(l=>l.other?['Outra avaria · a orçamentar',0]:[l.n+(l.sub?` · ${l.sub}`:''), l.now]);
  S.user.jobs=[{ref:lastRef,m:S.model,kind:kindOf(S.series),status:'booked',created:today,updated:today,items,deliv:S.deliv,store:storeObj()?storeObj().name:''},...(S.user.jobs||[])];
  if(S.deliv==='home') S.user.picks=[{ref:lastRef,m:S.model,status:'scheduled',date:S.date,dir:'in',track:'8402 '+String(1931+Math.floor(Math.random()*60))+' '+String(1000+Math.floor(Math.random()*8999)),addr:`${S.street}, ${S.door} · ${S.city}`},...(S.user.picks||[])];
  trkTab='rep'; renderTrack();
}
$$('.trk-tabs button').forEach(b=>b.addEventListener('click',()=>{trkTab=b.dataset.t;renderTrack()}));
$('#trk-list').addEventListener('click',e=>{ const b=e.target.closest('[data-open]'); if(b) openAccount(b.dataset.open,b.dataset.ref); });
$('#trk-all').addEventListener('click',()=>openAccount(trkTab));
$('#trk-associate').addEventListener('click',()=>{
  legacyLookupNeeded=true;
  renderTrack();
  $('#trk-ref').focus();
});
$('#trk-back').addEventListener('click',()=>{
  if(repairLinkModal){closeRepairLinkModal();return;}
  legacyLookupNeeded=false;
  $('#trk-ref').value='';
  $('#trk-err').hidden=true;
  $('#trk-result').hidden=true;
  $('#trk-result').innerHTML='';
  renderTrack();
});
$('#site-acc')?.addEventListener('click',()=>openAccount());
$('#trk-form').addEventListener('submit',async e=>{
  e.preventDefault();
  const ref=$('#trk-ref').value.trim().toUpperCase(), phone=$('#trk-phone').value.trim();
  const err=$('#trk-err'), result=$('#trk-result'), button=$('#trk-go');
  result.hidden=true; result.innerHTML='';
  if(!/^[A-Z0-9]{6}$/.test(ref)){ err.textContent='Confirma o código de 6 caracteres da reparação.'; err.hidden=false; $('#trk-ref').classList.add('bad'); $('#trk-ref').focus(); return; }
  if(!/^\+?[0-9\s().-]{9,22}$/.test(phone) || !/^(?:00)?[1-9][0-9]{8,14}$/.test(phone.replace(/\D/g,''))){ err.textContent='Confirma o telefone associado à reparação.'; err.hidden=false; $('#trk-phone').classList.add('bad'); $('#trk-phone').focus(); return; }
  err.hidden=true;
  const url=window.ISELL && window.ISELL.lookupUrl;
  if(!url){ err.textContent='A consulta está temporariamente indisponível. Tenta novamente mais tarde.'; err.hidden=false; return; }
  button.disabled=true;
  try{
    const response=await fetch(url,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify({repair_key:ref,phone})});
    const data=response.ok ? await response.json() : null;
    if(!response.ok || !data || !data.repair){
      err.textContent=response.status===404 ? 'Não encontrámos uma reparação com esse código e telefone.' : response.status===429 ? 'Demasiadas tentativas. Tenta novamente mais tarde.' : 'Não foi possível consultar a reparação. Tenta novamente.';
      err.hidden=false; return;
    }
    if(repairLinkModal&&!data.authenticated){
      result.innerHTML=legacyLookupResult(data,ref);
      result.dataset.budgetToken=data.access_token||'';
      $('#trk-form').hidden=true;
      repairLinkModal.classList.add('has-result');
      repairLinkModal.querySelector('.review-heading p').textContent='Referência #'+ref+' · Consulta validada';
    }else{
      result.innerHTML=repRowCard(mapRepair({...data.repair,repair_key:ref}),true);
      if(!portalState.authenticated && data.repair.review_available && !data.repair.reviewed){
        result.innerHTML+=`<div class="md-actions md-review-actions"><button type="button" class="btn green" data-guest-review="${esc(ref)}">Avaliar reparação</button></div>`;
      }
      const budget=data.repair.budget;
      if(budget&&Array.isArray(budget.lines)){
        const rows=budget.lines.map(l=>`<div><dt>${esc(l.description||'')}</dt><dd>${eur(+l.final_price||0)}</dd></div>`).join('');
        const actions=budget.state==='pending'&&data.access_token
          ? `<div class="md-actions" data-lookup-budget><button type="button" class="btn green" data-lookup-action="accept">Aprovar orçamento</button><button type="button" class="btn-ghost" data-lookup-action="decline">Recusar</button></div>`
          : `<p class="md-msg">${budget.state==='accepted'?'Orçamento aprovado.':budget.state==='declined'?'Orçamento recusado.':'Orçamento disponível.'}</p>`;
        result.innerHTML+=`<div class="card" style="padding:16px;margin-top:12px"><h3>Orçamento</h3><dl class="md-items">${rows}<div class="md-total"><dt>Total</dt><dd>${eur(+budget.total||0)}</dd></div></dl>${actions}</div>`;
        result.dataset.budgetToken=data.access_token||'';
      }
    }
    result.hidden=false;
    if(repairLinkModal&&!data.authenticated) result.querySelector('.legacy-result')?.focus({preventScroll:true});
    if(data.authenticated&&window.ISELL?.associateUrl){
      const association=await fetch(window.ISELL.associateUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify({repair_key:ref,phone})});
      if(association.ok) window.location.reload();
      else { err.textContent='Encontrámos a reparação, mas não foi possível associá-la à conta. Tenta novamente.'; err.hidden=false; }
    }
  }catch(_){ err.textContent='Não foi possível consultar a reparação. Verifica a ligação e tenta novamente.'; err.hidden=false; }
  finally{ button.disabled=false; }
});
$('#trk-result').addEventListener('click',async e=>{
  const reviewButton=e.target.closest('[data-guest-review]');
  if(reviewButton){openGuestReviewModal(reviewButton.dataset.guestReview);return;}
  const button=e.target.closest('[data-lookup-action]');if(!button)return;
  const action=button.dataset.lookupAction,box=$('#trk-result'),token=box.dataset.budgetToken,cfg=window.ISELL||{};
  if(!token||!cfg.budgetUrl)return;
  if(action==='decline'&&!confirm('Recusar o orçamento? Devolvemos o equipamento sem custos.'))return;
  box.querySelectorAll('[data-lookup-action]').forEach(b=>b.disabled=true);
  try{
    const r=await fetch(cfg.budgetUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify({access_token:token,action})});
    if(!r.ok)throw new Error('decision_failed');
    box.querySelector('[data-lookup-budget]').innerHTML=`<p class="md-msg t-green">${action==='accept'?'Orçamento aprovado.':'Orçamento recusado.'}</p>`;
  }catch(_){toast('Não foi possível registar a decisão. Tenta novamente.');box.querySelectorAll('[data-lookup-action]').forEach(b=>b.disabled=false);}
});
['#trk-ref','#trk-phone'].forEach(id=>$(id).addEventListener('input',()=>{$(id).classList.remove('bad');$('#trk-err').hidden=true}));

/* Newsletter */
$('#nl-form').addEventListener('submit',e=>{ e.preventDefault(); const v=$('#nl-email').value.trim();
  if(!emailOk(v)){ toast('Confirma o email para subscrever.'); $('#nl-email').focus(); return; }
  $('#nl-email').value=''; toast('Subscrito. Vais receber as novidades em '+v+'.'); });



$('#year').textContent=new Date().getFullYear();
renderTrack();
route();

update();

/* ===================== LIGAÇÃO AO BACKEND iSELL (App Proxy + conta Shopify) =====================
   Acrescentado a 2026-10-06. Mantém os preços estimados do protótipo (o servidor
   recalcula); liga o essencial: config real (lojas/feriados), cliente autenticado,
   e submissão real do pedido ao /apps/reparacoes/collect. Tudo dentro do IIFE,
   por isso tem acesso a S, STORES, HOLIDAYS, submit, signedIn, lines, etc. */
(function(){
  var CFG = window.ISELL || {};
  var cleanAddr = function(a){ return String(a||'').replace(/<[^>]+>/g,' ').replace(/,?\s*NIPC\s*:?\s*[\d.\s-]+/gi,'').replace(/\s{2,}/g,' ').replace(/[\s,]+$/,'').trim(); };
  var formatStoreAddress = function(s){
    var address=cleanAddr(s.address), zip=String(s.zip_code||'').trim(), city=String(s.city||'').trim();
    var hasZip=!!zip && address.includes(zip);
    var hasCity=!!city && address.toLocaleLowerCase('pt-PT').includes(city.toLocaleLowerCase('pt-PT'));
    if(hasZip && city && !hasCity) return address+' '+city;
    var missing=[zip && !hasZip?zip:'',city && !hasCity?city:''].filter(Boolean).join(' ');
    return [address,missing].filter(Boolean).join(' · ');
  };
  var storeBtn = function(s){ return '<button type="button" class="store" role="radio" aria-checked="false" data-s="'+s.id+'"><span class="pin"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 21s-7-6.1-7-11a7 7 0 0114 0c0 4.9-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/></svg></span><span><b>'+esc(s.name)+'</b><small>'+esc(s.addr)+'</small></span><span class="meta">'+s.hours.replace(' · ','<br>')+'</span></button>'; };
  var reqKey = function(){ try { return Array.from(crypto.getRandomValues(new Uint8Array(16)),function(b){return b.toString(16).padStart(2,'0')}).join(''); } catch(e){ return String(Date.now())+Math.random().toString(16).slice(2); } };
  var pendingRequest = null, submitting = false;

  /* ── Página /pages/historico (Meus Processos): a vista da conta do protótipo, com
     dados reais do App Proxy (/apps/reparacoes/mine). Só visual; sem aprovar/
     recusar nem campos que o backend ainda não devolve. ── */
  var isPortalPage = /\/pages\/(?:historico|meus-processos)\/?$/.test(location.pathname);
  // Um link enviado depois da entrega pode abrir logo a avaliação da reparação:
  // /pages/historico?review=H3PJL2
  var requestedReviewRef = null, requestedReviewHandled = false;
  var requestedRepairRef = null, requestedRepairHandled = false;
  try {
    var deepLink = new URLSearchParams(location.search);
    requestedReviewRef = (deepLink.get('review')||'').toUpperCase();
    requestedRepairRef = (deepLink.get('repair')||'').toUpperCase();
    if(!/^[A-Z0-9]{6}$/.test(requestedReviewRef)) requestedReviewRef=null;
    if(!/^[A-Z0-9]{6}$/.test(requestedRepairRef)) requestedRepairRef=null;
  } catch(e) {}
  if(requestedRepairRef){ legacyLookupNeeded=true; $('#trk-ref').value=requestedRepairRef; }
  function portalLoginUrl(){
    if(!CFG.loginUrl) return '';
    var url=new URL(CFG.loginUrl,location.origin);
    url.searchParams.set('return_to',location.pathname+location.search);
    return url.href;
  }
  function renderPortalAccount(){
    if(!isPortalPage) return;
    if(portalState.authenticated){
      S.user = {
        ...(S.user||{}),
        name:(CFG.customer&&CFG.customer.name)||(S.user&&S.user.name)||'',
        jobs:portalState.repairs.map(mapRepair),
        picks:portalState.pickups.map(p=>mapPickup(p, portalState.repairs))
      };
    } else {
      S.user = null;
      var gl = document.querySelector('#mr-gate a.btn');
      if(gl && CFG.loginUrl) gl.setAttribute('href', portalLoginUrl());
      var trackLogin = document.querySelector('.trk-login a');
      if(trackLogin && CFG.loginUrl) trackLogin.setAttribute('href', portalLoginUrl());
    }
    renderSavedAddresses();
    renderAccount();
    if(portalState.loading) return;
    if(!requestedRepairHandled && requestedRepairRef){
      requestedRepairHandled=true;
      var linkedRepair=S.user&&(S.user.jobs||[]).find(function(job){return job.ref.toUpperCase()===requestedRepairRef;});
      if(linkedRepair){legacyLookupNeeded=false;mrTab='rep';mrSel=linkedRepair.ref;mrQ='';$('#mr-q').value='';renderAccount();renderTrack();}
      else setTimeout(function(){openRepairLinkModal(requestedRepairRef);},0);
    }
    if (!requestedReviewHandled && requestedReviewRef) {
      requestedReviewHandled = true;
      var requestedRepair = S.user&&(S.user.jobs||[]).find(function(job){ return job.ref.toUpperCase() === requestedReviewRef; });
      if (requestedRepair) {
        mrTab = 'rep'; mrSel = requestedRepair.ref; renderAccount();
        if (requestedRepair.reviewAvailable && !requestedRepair.reviewed) setTimeout(function(){ openReviewModal(requestedRepair); }, 0);
      } else setTimeout(function(){ openGuestReviewModal(requestedReviewRef); }, 0);
    }
  }
  // Retoma o wizard depois do login Shopify: se há estado guardado recente,
  // restaura o equipamento/avarias e retoma o wizard no passo apropriado.
  var resumedRepair = false;
  try {
    if (restoreRepairResume()) {
      renderModelPicked(); repairSet(); renderRepairs(); bumpTotals();
      try { drawPad(); } catch(e){}
      // Retoma no passo da entrega se a sessão Shopify já estiver presente.
      // Caso contrário, mostra o login e avança assim que a conta for confirmada.
      navTo(FLOW_HASH); showView('flow');
      if(!S.reps.size){ $('#b-model').hidden=false; reveal('#b-issue',false); go(0); }
      else go(CFG.customer ? 1 : 'A');
      resumedRepair = true;
    }
  } catch(e){ resumedRepair = false; }

  if(isPortalPage && !resumedRepair){
    try{ const tab=new URLSearchParams(location.search).get('tab'); if(tab==='recolhas'||tab==='pickups') mrTab='pick'; }catch(e){}
    showView('account');
  }

  // A identidade e os processos vêm sempre do App Proxy assinado. Liquid só
  // preenche o formulário; nunca autoriza a listagem de outra conta.
  if (CFG.mineUrl) {
    // Loading mascarado: mostra skeletons enquanto o App Proxy responde.
    portalState.loading = true; renderTrack(); if (isPortalPage) renderPortalAccount();
    fetch(CFG.mineUrl, {method:'POST', headers:{Accept:'application/json'}, credentials:'same-origin'})
      .then(function(response){
        if (response.status === 401) return null;
        if (!response.ok) throw new Error('mine_unavailable');
        return response.json();
      })
      .then(function(data){
        portalState.loading = false;
        portalState.authenticated = !!data && Array.isArray(data.repairs) && Array.isArray(data.pickups);
        S.accountVerified = portalState.authenticated;
        portalState.repairs = data && Array.isArray(data.repairs) ? data.repairs : [];
        portalState.pickups = data && Array.isArray(data.pickups) ? data.pickups : [];
        if (S.accountVerified && !S.user) {
          $('#acc').classList.add('signed');
          $('#acc-forms').hidden=true;
          $('#acc-done').hidden=false;
          $('#acc-av').textContent='✓';
          $('#acc-hi').textContent='Conta Shopify confirmada';
          $('#acc-msg').textContent='Confirma os teus contactos no passo dos dados.';
          update();
        }
        if (S.accountVerified && S.step==='A') go(1);
        renderTrack();
        renderPortalAccount();
      })
      .catch(function(){ portalState.loading=false; portalState.error=!!CFG.customer; renderTrack(); renderPortalAccount(); });
  } else { portalState.loading=false; portalState.error=!!CFG.customer; renderTrack(); renderPortalAccount(); }

  // An optional Shopify tax ID must not delay the repair list or account check.
  if (CFG.taxIdUrl) {
    fetch(CFG.taxIdUrl, {method:'POST', headers:{Accept:'application/json'}, credentials:'same-origin'})
      .then(function(response){ return response.ok ? response.json() : null; })
      .then(function(data){
        const taxId=portugueseTaxId(data&&data.tax_id);
        if(taxId && !S.nif){
          if(S.user) S.user.nif=taxId;
          setField('nif',taxId);
        }
      })
      .catch(function(){});
  }

  // 1) Cliente autenticado → preenche e satisfaz o passo "Conta".
  if (CFG.customer) {
    var c = CFG.customer, u = { name:(c.name||c.email||'Cliente'), email:(c.email||''), tel:(c.tel||''), nif:'', addrs:[] };
    if (Array.isArray(c.addresses) && c.addresses.length) u.addrs = c.addresses;
    else if (c.address && (c.address.street || c.address.cp)) u.addrs = [{ label:'Morada da conta', street:(c.address.street||''), door:(c.address.door||''), cp:(c.address.cp||''), city:(c.address.city||'') }];
    try { signedIn(u, false); } catch(e){ console.error('Shopify customer prefill failed', e); }
  }

  // 2) Login/registo reais → redireciona para a Shopify (New Customer Accounts).
  if (CFG.loginUrl) {
    var shopifyLogin = document.getElementById('shopify-login');
    if (shopifyLogin){ shopifyLogin.href = CFG.loginUrl; shopifyLogin.addEventListener('click', function(){ saveRepairResume(); }); }
  }

  // 3) Config real: lojas + feriados do App Proxy.
  if (CFG.configUrl) {
    var storeHelp = document.getElementById('store-config-help');
    var storeList = document.getElementById('stores');
    fetch(CFG.configUrl, { method:'POST', headers:{ Accept:'application/json' }, cache:'no-store' })
      .then(function(r){ if (!r.ok) throw new Error('collection_config_unavailable'); return r.json(); })
      .then(function(cfg){
        if (!cfg || !Array.isArray(cfg.stores) || !cfg.stores.length) throw new Error('collection_stores_unavailable');
        if (Array.isArray(cfg.store_schedule?.holidays)) STORE_HOLIDAYS = cfg.store_schedule.holidays;
        if (cfg.occupied_store_slots && typeof cfg.occupied_store_slots === 'object') OCCUPIED_STORE_SLOTS = cfg.occupied_store_slots;
        if (/^\d{4}-\d{2}-\d{2}$/.test(cfg.store_schedule?.earliest_date||'')) STORE_EARLIEST_DATE = cfg.store_schedule.earliest_date;
        if (Number.isInteger(+cfg.store_schedule?.visible_days)) STORE_VISIBLE_DAYS = +cfg.store_schedule.visible_days;
        var stores = cfg.stores.map(function(s){
          var id=String(s.id||'');
          if (!/^[1-9]\d*$/.test(id)) throw new Error('invalid_collection_store_id');
          var h = s.hours || {};
          var sat = !!h.saturday;
          var hourOr = function(value, fallback){ var n=+value; return Number.isInteger(n)&&n>=0&&n<=24?n:fallback; };
          var hrs = { wkOpen:hourOr(h.weekday_open,9), wkClose:hourOr(h.weekday_close,19), sat:sat, satOpen:hourOr(h.saturday_open,10), satClose:hourOr(h.saturday_close,13) };
          var disp = 'Seg–Sex '+hrs.wkOpen+'h–'+hrs.wkClose+'h' + (sat ? ' · Sáb '+hrs.satOpen+'h–'+hrs.satClose+'h' : '');
          return { id:id, name:s.name, addr:formatStoreAddress(s), hours:disp, sat:sat, hrs:hrs };
        });
        STORES = stores;
        STORE_CONFIG_READY = true;
        if (storeList) storeList.innerHTML = STORES.map(storeBtn).join('');
        if (storeHelp) { storeHelp.textContent=''; storeHelp.classList.remove('err'); }
        if(S.store && S.sday){ renderHours(); update(); }
      }).catch(function(){
        STORE_CONFIG_READY = false;
        STORES = [];
        S.store = ''; S.sday = ''; S.hour = '';
        if (storeList) storeList.innerHTML = '';
        if (storeHelp) { storeHelp.textContent='Não foi possível carregar as lojas. Atualiza a página para tentar novamente.'; storeHelp.classList.add('err'); }
      });
  } else {
    var storeHelp = document.getElementById('store-config-help');
    if (storeHelp) { storeHelp.textContent='Não foi possível carregar as lojas. Atualiza a página para tentar novamente.'; storeHelp.classList.add('err'); }
  }

  // 4) Submissão real → cria o pedido no backend.
  function refreshPortalAfterBooking(){
    if(!CFG.mineUrl) return;
    fetch(CFG.mineUrl, {method:'POST', headers:{Accept:'application/json'}, credentials:'same-origin'})
      .then(function(response){ return response.ok ? response.json() : null; })
      .then(function(data){
        if(!data || !Array.isArray(data.repairs) || !Array.isArray(data.pickups)) return;
        portalState.repairs=data.repairs;
        portalState.pickups=data.pickups;
        portalState.authenticated=true;
        if(isPortalPage) renderPortalAccount();
        else if(S.user){
          S.user.jobs=data.repairs.map(mapRepair);
          S.user.picks=data.pickups.map(p=>mapPickup(p, data.repairs));
          renderTrack();
        }
      }).catch(function(){});
  }
  submit = function(){
    if (submitting) return;
    validateSelectedRepairs();
    if(!S.reps.size){ go(0); toast('Escolhe pelo menos uma avaria.'); return; }
    submitting = true;
    var btns=[document.getElementById('next-btn'),document.getElementById('mb-next')].filter(Boolean), orig=btns.map(function(b){return b.innerHTML;});
    btns.forEach(function(b){ b.setAttribute('aria-disabled','true'); b.innerHTML='<span class="spin" style="border-color:rgba(255,255,255,.35);border-top-color:#fff"></span> A agendar…'; });
    var restore=function(){ submitting=false; btns.forEach(function(b,i){ b.removeAttribute('aria-disabled'); b.innerHTML=orig[i]; }); };

    var items=[]; S.reps.forEach(function(r,n){ if(r.kind==='o'){ items.push({product:S.model,repair:n,price:'0,00 €',original_price:'0,00 €'}); } else { var p=priceOf(n,r.base,r.variant); var label=r.variant?(n+' · '+r.variant):n; items.push({product:S.model,repair:label,price:eur(p),original_price:eur(p)}); } });
    var unlock = S.lock==='none' ? 'Sem bloqueio' : (S.lock==='pattern' ? ('Padrão: '+S.pattern.map(function(i){return i+1;}).join('-')) : ('PIN: '+S.pin));
    var body = { device_model:S.model, unlock_code:(unlock||'-'), comment:(S.desc||''), delivery_type:S.deliv, client_name:S.name, email:S.email, contact_number:contactNumberForBooking(S.tel), nif_tax_id:S.nif, terms:(S.terms?'on':''), items:items };
    if (S.deliv==='home') { body.country='Portugal'; body.city=S.city; body.zip_code=S.cp; body.address=S.street; body.door_number=S.door; body.collection_date=S.date; }
    else { body.store_id=S.store; body.store_delivery_date=S.sday; body.store_delivery_time=S.hour; }
    // Reuse the same key for an identical retry: the server can then return
    // the original SOS if it committed but the browser lost the response.
    var payload = JSON.stringify(body);
    if (!pendingRequest || pendingRequest.payload !== payload) pendingRequest = {payload:payload, key:reqKey()};
    body.request_key = pendingRequest.key;

    fetch(CFG.collectUrl, { method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body: JSON.stringify(body) })
      .then(function(r){ return r.json().catch(function(){return {};}).then(function(j){ return { ok:r.ok, status:r.status, j:j }; }); })
      .then(function(res){
        if (!res.ok) { var failure=new Error(res.j && res.j.error || 'request_failed'); failure.status=res.status; failure.field=res.j && res.j.field; throw failure; }
        pendingRequest = null;
        lastRef = String(res.j.sos_id || res.j.id || res.j.ref || nextRef());
        document.getElementById('ref').textContent='#'+lastRef;
        var first=(S.name||'').split(/\s+/)[0]||'';
        document.getElementById('done-title').textContent='Recebemos o teu pedido, '+first;
        if (S.deliv==='home') {
          document.getElementById('done-sub').textContent='Pedimos a recolha em '+S.street+(S.door?', '+S.door:'')+' para '+(S.dateLabel||'a data escolhida').toLowerCase()+'. Confirmaremos o agendamento por mensagem. Total estimado '+totalLabel()+'.';
          document.getElementById('done-email-status').textContent='Guarda a referência do pedido até receberes a confirmação.';
          document.getElementById('next').innerHTML='<div><b>Prepara o equipamento</b><p>Desativa o "Encontrar" e faz uma cópia de segurança. O estafeta leva a embalagem.</p></div><div><b>Recolha</b><p>Recebes um SMS com a janela exata na véspera.</p></div><div><b>Orçamento</b><p>Diagnóstico no dia útil em que chega. Só reparamos depois de aprovares.</p></div>';
        } else {
          var sName=(storeObj()&&storeObj().name)||'loja escolhida';
          document.getElementById('done-sub').textContent='Esperamos-te na '+sName+', '+(sdayLabel()||'').toLowerCase()+' às '+S.hour+'. Total estimado '+totalLabel()+'.';
          document.getElementById('done-email-status').textContent=res.j.warning==='store_confirmation_email_failed'
            ? 'Não conseguimos enviar o email de confirmação. Guarda a referência do pedido.'
            : res.j.existing ? 'Este pedido já estava registado. Consulta o email ou guarda a referência.'
            : 'Enviámos a confirmação para '+S.email+'.';
          document.getElementById('next').innerHTML='<div><b>Traz o equipamento</b><p>Com o carregador, se a avaria for de carga ou bateria. Mostra a referência ao balcão.</p></div><div><b>Diagnóstico</b><p>Muitas reparações ficam prontas no mesmo dia.</p></div><div><b>Orçamento</b><p>Só reparamos depois de aprovares o valor final.</p></div>';
        }
        $('#done-title').textContent='Pedido recebido';
        $('#ref').textContent='Agendamento #'+lastRef;
        $('#done-slot-icon').innerHTML=S.deliv==='home'?ICON.truck:STORE_ICON;
        $('#done-slot-label').textContent=S.deliv==='home'?'Recolha agendada':((storeObj()&&storeObj().name)||'Loja escolhida');
        $('#done-slot-date').textContent=S.deliv==='home'?dShort(S.date):dShort(S.sday)+' às '+S.hour;
        $('#done-slot-note').textContent=S.deliv==='home'?'Confirmamos o agendamento por SMS.':'Entrega do equipamento na loja escolhida.';
        $('#done-device-icon').innerHTML=kindIcon(kindOf(S.series));
        $('#done-device').textContent=S.model;
        $('#done-total').textContent=totalLabel();
        $('#done-total').classList.toggle('quote-total',S.reps.has('Outra avaria') && ![...S.reps.keys()].some(n=>n!=='Outra avaria'));
        restore(); go(4); refreshPortalAfterBooking();
      })
      .catch(function(err){
        restore();
        console.warn('Pedido de reparação não confirmado', {status:err.status||0, code:err.message, field:err.field||''});
        if(err.message==='store_slot_unavailable' && S.deliv==='store'){
          var busy=OCCUPIED_STORE_SLOTS[String(S.store)]||(OCCUPIED_STORE_SLOTS[String(S.store)]=[]);
          if(!busy.includes(S.sday+' '+S.hour)) busy.push(S.sday+' '+S.hour);
          renderHours(); update(); go(2);
        }
        var map={ store_slot_unavailable:'Esta hora já foi reservada. Escolhe outra.', invalid_store_delivery_slot:'Esta hora já não está disponível para entrega. Escolhe outra.', invalid_store_delivery_date:'Escolhe um dia de entrega válido.', invalid_store_delivery_time:'Escolhe uma hora de entrega válida.', invalid_collection_date:'Escolhe uma data de recolha válida.', invalid_store:'A loja ainda não está disponível. Atualiza a página e escolhe-a novamente.', missing_field:'Faltam dados obrigatórios'+(err.field ? ': '+err.field : '')+'.', invalid_email:'Confirma o endereço de email.', invalid_postal_code:'Confirma o código postal.', missing_quote:'Seleciona pelo menos uma reparação.', too_many_collection_attempts:'Há demasiadas tentativas. Aguarda alguns minutos antes de voltar a tentar.', proxy_signature_required:'A ligação à loja falhou. Atualiza a página e tenta novamente.', sos_create_failed:'O sistema não confirmou o pedido. Verifica primeiro em As minhas reparações antes de voltar a tentar.' };
        try { toast(map[err.message] || 'Pedido não confirmado ('+(err.status||'rede')+' / '+err.message+'). Verifica em As minhas reparações antes de repetir.'); } catch(e){}
      });
  };
})();

})();
